import momentJalaali from "moment-jalali";
import { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { Accordion, Button, Card, Col, FormCheck, FormGroup, OverlayTrigger, Popover, Row, Table, Form, Toast, ToastBody, ToastHeader } from 'react-bootstrap';
import {
    ArrowLeft, ArrowRightSquare, BagDash, BoxArrowInDownLeft, Calculator, Check2Circle, CheckLg, Clipboard2Check, Clock, CloudArrowUp, CloudDownload, Command, DashCircle, Envelope,
    EnvelopePaper, FileEarmarkCheck, GeoAltFill, Headset, ImageAlt, ImageFill, InfoCircle, LayoutTextSidebar, LayoutWtf, List, Pencil, PencilFill, Person, PersonSquare, Plus, Printer, Receipt,
    ReceiptCutoff, ReplyFill, Toggle2On, Toggles, Toggles2, Trash, Truck, Upload, BoxArrowRight,
    Calendar2Day,
    FileEarmarkPost,
    StopCircle,
    CircleFill,
    CalendarDate
} from "react-bootstrap-icons";
import DatePicker from 'react-datepicker2';
import "react-datepicker2/src/styles/style.css";
import { useForm } from 'react-hook-form';
import Loader from 'react-loader-spinner';
import { databaseEntities, getJalaliDiff, InfoTypes, networkManager_CheckIn, networkManager_CheckOut, setErrorDialog, useIsMobileApp } from "../../store/api/CommonFunctions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import ModalProducts from "../../Components/Modals/ModalProducts";
import ModalReferDocument from '../../Components/Modals/ModalReferDocument';
import ModalSelectCustomer from '../../Components/Modals/ModalSelectCustomer';
import Signature from '../Components/Signature';
import ModalDefinedServices from '../Components/Tasks/ModalDefinedServices';
import ModalReferToOther from "../Components/Tasks/ModalReferToOther";
import ModalSelectFaultByCustomer from '../Components/Tasks/ModalSelectFaultByCustomer';
import ModalSelectProductBug from '../Components/Tasks/ModalSelectProductBug';
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import ModalSerialHistory from "../Components/Tasks/ModalSerialHistory";
import RepairBugs from '../Components/Tasks/RepairBugs';
import ServiceCheckboxAttr from '../Components/Tasks/ServiceCheckboxAttr';
import ServiceDefinedServices from '../Components/Tasks/ServiceDefinedServices';
import ServiceExtraCosts from '../Components/Tasks/ServiceExtraCosts';
import ServiceReferrals from '../Components/Tasks/ServiceReferrals';
import ServicesExtAttr from '../Components/Tasks/ServicesExtAttr';
import ServiceUsedParts from '../Components/Tasks/ServiceUsedParts';
import ServiceProductAccessories from '../Components/Tasks/Service_ProductAccessories';
import IsArchivePic from "../content/images/IsArchive.png";
import PastDuration from "../content/images/PastDuration.png";
//import { convertChar } from '../store/api/ConvertToEnglish';
import { getSwappedFromInfo, removeSwappedSerial, updateGuarantee } from '../store/api/GuaranteeApi';
import { getAllProvinces, getCityList, getZoneList } from '../store/api/LocationAPI';
import { setMapPop } from '../store/api/Modals';
import { keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import ModalCommands from "../../Components/Modals/ModalCommands";
import {
    applyService, deleteAttachment, getRelatedStaffsToAgent, getRepairBugList,
    getServiceAttachments, getServiceWithCallBack, getStaffReportList, setCustomerFaultsPop,
    setReferServicePopup, setSerialHistoryPopup, setSignaturePop, getLastServiceNumber, getMessageList, getServiceStaffPayments, removeArchiveService,
    getServiceStatusList, changeServiceStatus, deleteService, getCustomerServiceCount, getCustomerServiceCountByID, updateServiceConsideration,
    stopService,
    resumeService,
    verifyServiceDone,
    getProductGuaranteeInfo
} from "../store/api/Services";
import { getExtAttrSettings, getSystemSettings } from "../store/api/SystemSettingsAPI";
import { getBaseInfoList } from "../../BaseInfo/store/api/BaseInfoApi";
import { loadServiceAccessories } from "../store/api/TaskDetailsApi";
import { getPageFieldList } from "../store/api/Users";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardCheck, faStopCircle, faToolbox } from "@fortawesome/free-solid-svg-icons";
import ModalMap from "../Components/ModalMap";
import ServiceEvents_Messages from "../Components/Tasks/ServiceEvents_Messages";
import ServiceAccountings from "../Components/Tasks/ServiceAccountings";
import { getServiceEvents } from "../store/api/CustomerApi";
import { getDefaultStoragesInfo, setDialog } from "../store/api/GetAllProduct";
import ModalHappyCall from "../../Components/Modals/ModalHappyCall";
import ModalSendSMS from "../../Components/Modals/ModalSendSMS";
import ServiceDeliverProduct from "../Components/Tasks/ServiceDeliverProduct";
import ModalGuaranteeSubProducts from "../Components/ModalGuaranteeSubProducts";
import ModalSwapSerial from "../Components/Tasks/ModalSwapSerial";
import { downloadFile, attachFile } from "../../store/api/CommonFunctions";
import BihamtaTable from "../../Components/BihamtaTable";
import ModalServiceDelivery from "../Components/Tasks/ModalServiceDelivery";
import ModalServiceAccounting from "../Components/Tasks/ModalServiceAccounting";
import ModalServiceEvents from "../Components/Tasks/ModalServiceEvents";
import { getDocumentIDByAttachment } from "../../Accounting/store/api/DocumentsAPI";
import ModalReminder from "../../Components/Modals/ModalReminder";
import VoiceRecorder from "../../Components/VoiceRecorder";
import PopSMSOtp from "../../Components/PopSMSOtp";
const Service = () => {
    const dispatch = useDispatch();
    const isMobile = useIsMobileApp();
    const webView = !isMobile;
    const [attachFileType, setAttachFileType] = useState("file");
    const [considerDescList, setConsiderDescList] = useState(null);
    const [stopDescList, setStopDescList] = useState(null);
    const roleList = JSON.parse(localStorage.getItem("RoleList"));
    const { serviceAccessories, fieldList, serviceExtraAttrSettings, systemSettings, provinceList, cityList, zoneList, currentLocation,
        serviceAttachments, staffReportList, repairBugList, signaturePopStaus, serviceStatusList, defaultStorages } =
        useSelector(state => {
            return {
                serviceStatusList: state.service.serviceStatusList,
                repairBugList: state.service.repairBugList,
                fieldList: state.UserReducer.pageFieldList,
                cityList: state.locationDataReducer.cityList,
                zoneList: state.locationDataReducer.zoneList,
                staffReportList: state.service.staffReportList,
                signaturePopStaus: state.service.signaturePopStaus,
                serviceAttachments: state.service.serviceAttachments,
                provinceList: state.locationDataReducer.provinceList,
                defaultStorages: state.ProductReducer.defaultStorages,
                serviceAccessories: state.taskDetails.serviceAccessories,
                currentLocation: state.locationDataReducer.currentLocation,
                systemSettings: state.SystemSettingsReducer.systemSettings,
                saveServiceInvoiceResult: state.service.saveServiceInvoiceResult,
                serviceExtraAttrSettings: state.SystemSettingsReducer.serviceExtraAttrSettings
            }
        });
    const { serviceType, serviceID } = useParams();
    const showReceipt = /*webView &&*/ Number(serviceID) > 0;
    const history = useHistory();
    const location = useLocation();
    const cardInfo = location.state;
    if (cardInfo) {
        history.replace({ pathname: history.location.pathname, state: null });
    }
    const checkOut = useRef(true);
    const statusID = useRef(0);
    const divButtons = useRef();
    let buttonsArray = useRef([]);
    const considerDescInput = useRef()
    const [showMenuButton, setShowMenuButton] = useState(false);
    const minDate = momentJalaali().subtract(1, "day");
    const [checkedIn, setCheckedIn] = useState(true);
    const [serviceInfo, setServiceInfo] = useState(null);
    const [parentStaffID, setParentStaff] = useState(null);
    const [popStaff, setPopStaff] = useState({ show: false });
    const [popProduct, setPopProduct] = useState({ show: false });
    const [popCustomer, setPopCustomer] = useState({ show: false });
    const [popCommand, setPopCommand] = useState({ show: false });
    const [modalHappyCall, setModalHappyCall] = useState({ show: false });
    const isLoadingSaved = useSelector(state => state.loading?.isLoading);
    const { register, handleSubmit, errors } = useForm();
    const [gStartDate, setStartDate] = useState(null);
    const [gEndDate, setEndDate] = useState(null);
    const [firstContactDate, setContactDate] = useState(null);
    const [serviceDeadline, setDeadline] = useState(null);
    const [durationalDeadline, setDurationalDeadline] = useState(null);
    const [productCreationDate, setProductCreationDate] = useState(null);
    const [selectedStaff, setStaffData] = useState(null);
    const [serviceIsGuarantee, setServiceGuarantee] = useState(false);
    const [customerServiceCount, setCustomerServiceCount] = useState(null);
    const [productGCardMoreInfo, setProductGCardMoreInfo] = useState(null);
    const [modalSMS, setModalSMS] = useState({ show: false });
    const [popReferDoc, setReferDocPop] = useState({ show: false });
    const [modalSubProducts, setModalSubProducts] = useState({ show: false });
    const [modalSwapSerial, setModalSwapSerial] = useState({ show: false });
    const [sendStatusSMS, setSendStatusSMS] = useState(false);
    const [modalDelivery, setModalDelivery] = useState({ show: false });
    const [modalServiceAcc, setModalServiceAcc] = useState({ show: false });
    const [modalServiceEvents, setModalServiceEvents] = useState({ show: false });
    const [popReminder, setPopReminder] = useState({ show: false });
    const settingNames = ['ProductGrouppingType', 'NationalCodeIsRequired', 'Services_SerialObligatoryInInstall', 'Services_SerialObligatoryInRepair', 'SendInstallDoneSMSToCustomer', 'SendRepairDoneSMSToCustomer',
        "SendingSMS_SendServiceDoneSMSBodyToCustomer", "DefaultSettleSalesInvoice", "Services_ProductSerial_IsEnglish", "Services_AutoInvoiceForUsedparts", "ProductDefaultSalePrice", "Services_ReduceFromStorage",
        "ProductDefaultSalePriceLabel", "Services_Type1_ServiceDiscountAffectOnStaffShareID", "Services_Type3_ServiceDiscountAffectOnStaffShareID", "SMS_InformCustomerOnCreateInstall",
        "SMS_InformCustomerOnCreateRepair", "SendingSMS_InformCustomerOnServiceCreate", "Services_ChoosingLocationIsObligatory", "ServiceTypeDefaultValue", "Services_SerialReadonlyInReception", "AddGuaranteeFromService",
        "Services_Type1_AccountingDocumentCreationTypeID", "Services_Type2_AccountingDocumentCreationTypeID", "Services_Type3_AccountingDocumentCreationTypeID", "InformCustomerOnStaffReferral", "Services_AutoOldPartsForUsedparts"];
    const productGrouppingType = systemSettings && Array.isArray(systemSettings) && systemSettings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const nationalCodeIsRequired = Array.isArray(systemSettings) && systemSettings.find(s => s.SettingName === "NationalCodeIsRequired")?.SettingValue.toLowerCase() === "true";
    const serialIsReadonly = systemSettings.find?.(s => s.SettingName === "Services_SerialReadonlyInReception")?.SettingValue.toLowerCase() === "true" || (Number(serviceInfo?.GuaranteeCardID) > 0 && serviceInfo.SerialNumber?.length > 0);
    const serialIsEnglish = systemSettings && systemSettings.find(s => s.SettingName === "Services_ProductSerial_IsEnglish")?.SettingValue.toLowerCase() === "true";
    const locationIsRequired = Array.isArray(systemSettings) && systemSettings.find(s => s.SettingName === "Services_ChoosingLocationIsObligatory")?.SettingValue.toLowerCase() === "true";
    const pDefaultSalePrice = systemSettings && Array.isArray(systemSettings) ? systemSettings.find(s => s.SettingName === "ProductDefaultSalePrice")?.SettingValue : "";
    const pDefaultSalePriceLabel = systemSettings && Array.isArray(systemSettings) ? systemSettings.find(s => s.SettingName === "ProductDefaultSalePriceLabel")?.SettingValue : "";
    const [serialIsRequired, setSerialReq] = useState((serviceType === "install" && systemSettings?.find(s => s.SettingName === "Services_SerialObligatoryInInstall")?.SettingValue.toLowerCase() === "true") ||
        (serviceType === "repair" && systemSettings?.find(s => s.SettingName === "Services_SerialObligatoryInRepair")?.SettingValue.toLowerCase() === "true"));
    let defaultServicType = Array.isArray(systemSettings) ? (systemSettings.find(s => s.SettingName === "ServiceTypeDefaultValue")?.SettingValue ?? "install") : "install";;
    let inDeliverStateAtLoad = false;
    const enableExit = serviceInfo?.AuthorizedStatusHardCodes?.some(s => s === "deliveredtocust") || serviceInfo?.AuthorizedStatusHardCodes?.some("senttocust");
    const addCard = systemSettings?.find?.(s => s.SettingName === "AddGuaranteeFromService")?.SettingValue?.toLowerCase() === "true";
    const enablePriority = true;/* serviceInfo &&
        serviceInfo.StageHardCode === "Distribution" &&
        !serviceInfo.SendDeliveryDate && !serviceInfo.IsArchive &&
        (!(Number(serviceInfo.AgencyID) > 0) || (Number(serviceInfo.AgencyID > 0) && !serviceInfo.ReceptionInAgent))*/
    const attachTableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "PAttachDate", colTitle: "تاریخ پیوست", showInMobile: true },
        { colName: "AttachFileName", colTitle: "نام فایل پیوست", colType: "string" },
        { colName: "MoreInfo", colTitle: "توضیحات", colType: "string" },
        { colName: "ImageThumbnail", colTitle: <ImageFill size={18} />, colType: "img", onClick: (item) => { console.log(item); downloadFile(item.ID, serviceType, true); } }

    ]
    const attachTableButton = [
        {
            title: "دانلود فایل", type: "common", className: "group-Btn-smalll btn-success", onclick: (item) => { downloadFile(item.ID, serviceType, false); }, icon: <CloudDownload size={18} color="blue" />

        },
        {
            title: "حذف فایل", type: "delete", onclick: (item) => { deleteAttach(item.ID) }, className: "group-Btn-smalll"
        }
    ]
    const popStopService = (
        <Popover id="popStopService" style={{ fontFamily: "Vazir", minWidth: "350px" }} onClick={e => e.stopPropagation()}>
            <Popover.Title className="headerStyle"><FontAwesomeIcon icon={faStopCircle} size="lg" /> توقف سرویس</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ paddingTop: "2px" }}>
                {stopDescList?.Data &&
                    <FormGroup>
                        <select className="tableRowInput" onChange={e => { setServiceInfo({ ...serviceInfo, StopDesc: e.target.value }); console.log(e) }}>
                            <option value="">انتخاب کنید</option>
                            {stopDescList.Data.map((desc, i) => <option key={i} value={desc.InfoName}>{desc.InfoName}</option>)}
                        </select>
                        <Form.Control value={serviceInfo?.StopDesc ?? ""} onChange={e => { setServiceInfo({ ...serviceInfo, StopDesc: e.target.value }); console.log(e) }} />
                        <Button className="group-Btn mt-1" variant="info" onClick={stop} disabled={serviceInfo?.IsArchive || serviceInfo?.SendDeliveryDate}><CheckLg size={18} />&nbsp;ثبت اطلاعات</Button>
                    </FormGroup>
                }
            </Popover.Content>
        </Popover>
    )
    const popMenu = (
        <Popover id="popMenu" style={{ fontFamily: "Vazir" }}>
            <Popover.Title className="headerStyle" style={{ paddingRight: "2px" }}><List size={18} /> سایر عملیات</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ padding: "2px" }}>
                {showReceipt && buttonsArray.current.includes("custReceipt") && <div className="popMenuItem" onClick={printServiceReceipt}><Receipt size={15} /> رسید مشتری</div>}
                {Number(serviceID) > 0 &&
                    <Fragment>
                        {buttonsArray.current.includes("referDoc") && checkedIn && <div className="popMenuItem" onClick={showDocRefer}><ReplyFill size={15} /> ارجاع به کارتابل کاربر</div>}
                        {buttonsArray.current.includes("command") && <div className="popMenuItem" onClick={showCommand}><Command /> دستور کار</div>}
                        {buttonsArray.current.includes("happyCall") && <div className="popMenuItem" onClick={showModalHappyCall}><Headset size={17} /> رضایت سنجی</div>}
                        {buttonsArray.current.includes("referStaff") && checkedIn && <div className="popMenuItem" onClick={showReferPop}><ArrowRightSquare size={17} />&nbsp;ارجاع به تکنسین</div>}
                        {buttonsArray.current.includes("staffForm") && <div className="popMenuItem" onClick={printStaffServiceForm}><Receipt size={15} />&nbsp; فرم تکنسین </div>}
                        {buttonsArray.current.includes("sms") && <div className="popMenuItem" onClick={sendSMSToCustomer}> <Envelope size={15} />&nbsp;ارسال پیامک به مشتری</div>}
                        {buttonsArray.current.includes("reminder") && <div className="popMenuItem" onClick={showModalReminder}><CalendarDate size={18} />&nbsp;یادآوری</div>}
                        {buttonsArray.current.includes("gotoDoc") && <div className="popMenuItem" keyname="gotoDoc" onClick={gotoDocument}><FileEarmarkPost size={15} />&nbsp;سند حسابداری</div >}
                        {!serviceInfo?.StoppedInStatus && buttonsArray.current.includes("stop") &&
                            <OverlayTrigger placement="top" trigger="click" overlay={popStopService} keyname="stop">
                                <div className="popMenuItem" keyname="stop"><StopCircle size={15} />&nbsp;توقف سرویس</div>

                            </OverlayTrigger>}
                        {serviceInfo?.StoppedInStatus && buttonsArray.current.includes("resume") &&
                            <div className="popMenuItem" onClick={resume} keyname="resume"><CircleFill size={15} />&nbsp;ادامه کار</div>
                        }
                    </Fragment>
                }
                {serviceType.toLowerCase() === "repair" && !serviceInfo?.IsArchive && serviceInfo?.SerialNumber?.length > 0 &&
                    !(Number(serviceInfo?.NewProductID) > 0) && buttonsArray.current.includes("swap") && <div className="popMenuItem" onClick={showModalSwapSerial}><Toggle2On size={18} />&nbsp;جایگزینی محصول</div>}
                {Number(serviceID) > 0 && buttonsArray.current.includes("delete") &&
                    <div className="popMenuItem" onClick={delService}><DashCircle size={15} />&nbsp;حذف سرویس</div>
                }

            </Popover.Content>
        </Popover>
    )
    const popConsiderDescs = (
        <Popover id="popConsiderDescs" style={{ fontFamily: "Vazir" }}>
            <Popover.Title className="headerStyle"><FontAwesomeIcon icon={faClipboardCheck} size="lg" /> شرح رسیدگی</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ paddingTop: "2px" }}>
                {considerDescList?.Data &&
                    <FormGroup>
                        <select className="tableRowInput" defaultValue={serviceInfo?.ConsiderDescriptionID ?? ""} ref={considerDescInput}>
                            <option value="">انتخاب کنید</option>
                            {considerDescList.Data.map((desc, i) => <option key={i} value={desc.ID}>{desc.InfoName}</option>)}
                        </select>
                        <Button className="group-Btn mt-1" variant="info" onClick={updateConsideration} disabled={serviceInfo?.IsArchive || serviceInfo?.SendDeliveryDate}><CheckLg size={18} />&nbsp;ثبت ملاحظه</Button>
                    </FormGroup>
                }
            </Popover.Content>
        </Popover>
    )
    function showModalProduct(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data) {
                //selectProduct(data);
                setServiceInfo({ ...serviceInfo, ...data, GuarantyCode: data.GuaranteeCardNo })
            }
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData });
    }
    function showModalStaff(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            if (data) {
                setStaffData(data);
            }
        }
        setPopStaff({ show: true, forAgency: true, onSelect: onSelect });
    }
    function showModalCustomer(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectCustomer = (data) => {
            if (data) {
                setServiceInfo({
                    ...serviceInfo, CustomerID: data.ID,
                    CustomerName: data.Name,
                    CustomerMobile: data.Mobile,
                    CustomerPhone: data.Phone,
                    ServiceAddress: data.Address,
                    Latitude: data.Latitude,
                    ProvinceID: data.ProvinceID,
                    CityID: data.CityID,
                    ZoneID: data.ZoneID,
                    Longitude: data.Longitude,
                    CustomerCode: data.Code
                })
                getCustomerServiceCount(data.Code, setCustomerServiceCount);
                setSelectedCustomerLocation(data.ProvinceID, data.CityID);
            }
        }
        setPopCustomer({ show: true, value: e.key, invoiceCustomers: false, setCustomerData: onSelectCustomer });
    }
    function showModalMiddleman(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            if (data) {
                setServiceInfo({
                    ...serviceInfo,
                    MiddlemanID: data.ID,
                    MiddlemanName: data.Name,
                    MiddlemanCat: data.Cat
                })
            }
        }
        setPopCustomer({ show: true, value: e.key, invoiceCustomers: true, setCustomerData: onSelect });
    }
    function showReferPop() {
        if (serviceID !== "0" && serviceInfo && serviceInfo.IsNotInLastDuration) {
            setErrorDialog(dispatch, "این سرویس مربوط به دوره مالی قبل است و امکان ارجاع آن وجود ندارد", "ارجاع سرویس");
            return;
        }
        if (serviceID !== "0" && serviceInfo && serviceInfo.IsArchive) {
            setErrorDialog(dispatch, "این سرویس بایگانی شده و امکان ارجاع آن وجود ندارد", "ارجاع سرویس");
            return;
        }
        let referrable = serviceInfo.StageHardCode === "Workshop" || serviceInfo.StageHardCode === "Reception" || serviceInfo.StageHardCode === "Distribution";
        if (!referrable) {
            setErrorDialog(dispatch, "ارجاع سرویس تنها در مراحل : پذیرش، توزیع و تعمیرگاه امکانپذیر است", "ارجاع سرویس");
            return;
        }
        let parentID = null;
        if (Number(serviceInfo?.AgencyID) > 0 && serviceInfo.ReceptionInAgent.toString().toLowerCase() === "true") {
            parentID = serviceInfo.AgencyID
        }
        dispatch(getRelatedStaffsToAgent({ ParentID: parentID, ProvinceID: serviceInfo.ProvinceID, CityID: serviceInfo.CityID }));
        dispatch(setReferServicePopup({ show: true, serviceID: serviceID, serviceType: serviceType }));
    }
    function printServiceReceipt(e) {
        const showPrint = () => {
            history.push({
                pathname: "/PrintViewer/ServiceReceipt/" + e.ctrlKey,
                state: {
                    dataUrl: `ReceptionTasksApi/GetServiceReceipt?serviceID=${serviceID}&serviceType=${serviceType}`,
                    method: "get"
                }
            });
        }
        if (!e.ctrlKey && !serviceInfo.HasReceiptSignature) {
            dispatch(setSignaturePop({
                show: true, parentID: serviceID, parentType: serviceType + "receipt",
                onSave: showPrint,
                onClose: showPrint
            }))
        }
        else {
            showPrint();
        }
    }
    function printStaffServiceForm(e) {
        history.push({
            pathname: "/PrintViewer/StaffServiceForm/" + e.ctrlKey,
            state: {
                dataUrl: `ReceptionTasksApi/GetServiceReceipt?serviceID=${serviceID}&serviceType=${serviceType}`,
                method: "get"
            }
        });

    }
    function printGuaranteeCard(e) {
        history.push({
            pathname: "/PrintViewer/GuaranteeCard/" + e.ctrlKey,
            state: {
                jsonObject:
                {
                    GuaranteeStartDate: momentJalaali(serviceInfo.GuaranteeStartDate).local("en").format("jYYYY/jMM/jDD"),
                    GuaranteeEndDate: momentJalaali(serviceInfo.GuaranteeEndDate).local("en").format("jYYYY/jMM/jDD"),
                    ProductName: serviceInfo.ProductName,
                    ProductModel: serviceInfo.ProductModel,
                    ProductCode: serviceInfo.ProductCode,
                    SerialNumber: serviceInfo.SerialNumber,
                    CustomerName: serviceInfo.CustomerName,
                    GuaranteeCardNo: serviceInfo.GuarantyCode,
                    GuaranteeTimeInMonth: serviceInfo.GuaranteeTimeInMonth
                }
            }
        });

    }
    function setRowButtonsAlignment(b) {
        const el = divButtons.current;
        buttonsArray.current = [];
        setShowMenuButton(false);
        if (el) {
            const maxWidth = el.clientWidth - 120;
            const buttons = el.querySelectorAll(".group-Btn");
            for (let i = 0; i < buttons.length; i++) {
                buttons[i].style.display = "unset";
            }
            let sumWidth = 0;
            for (let i = 0; i < buttons.length; i++) {
                const currentBtnWidth = buttons[i].offsetWidth;
                sumWidth += currentBtnWidth;
                const keyName = buttons[i].getAttribute("keyname");
                if (sumWidth >= maxWidth || currentBtnWidth === 0) {
                    buttons[i].style.display = "none";
                    if (keyName) {
                        buttonsArray.current.push(keyName);
                    }
                }
            }
            if (buttonsArray.current?.length > 0) {
                setShowMenuButton(true);
            }
        }
    }
    function printInvoice2(e) {
        history.push({
            pathname: "/PrintViewer/ServiceInvoice2/" + e.ctrlKey,
            state: {
                dataUrl: `ReceptionTasksApi/GetServiceTotalCost?serviceID=${serviceID}&serviceType=${serviceType}`,
                method: "get"
            }
        });
    }
    const loadCityList = (provinceID) => {
        serviceInfo.ProvinceID = provinceID;
        if (errors.ProvinceID && provinceID > 0) {
            errors.ProvinceID = null;
        }
        dispatch(getCityList(provinceID));
    }
    const loadZoneList = (cityID) => {
        //selectedCustomer.CityID = cityID;
        if (errors.CityID && cityID > 0) {
            errors.CityID = null;
        }
        dispatch(getZoneList(cityID));
    }
    const changeZone = (zoneID) => {
        //loadZoneList(selectedCustomer.CityID);
        //selectedCustomer.ZoneID = zoneID;
    }
    const setCustomerAndProductFromSerial = (item) => {

        if (item.GuaranteeStartDate?.length > 0 || Number(item.ID) > 0 || Number(item.CardID) > 0) {

            setServiceGuarantee(true);
            //اگر از کارت گارانتی آمده باشد مقدارش null است.
            if (serviceInfo) {
                serviceInfo.GuaranteeTimeInMonth = item.GuaranteeTimeInMonth;
                serviceInfo.GuaranteeStartDate = item.GuaranteeStartDate;
                serviceInfo.GuaranteeEndDate = item.GuaranteeEndDate;
                calcG_TimeInMonth(serviceInfo.GuaranteeStartDate);
            }
            item.RemainedGuarantee = calcG_RemainedTime(item.GuaranteeEndDate);
        }
        //selectProduct(item);
        if (item.CustomerID) {
            item.Longitude = item.Longtitude;
            if (item.CustomerAddress)
                item.ServiceAddress = item.CustomerAddress;
            else if (item.Address) {
                item.ServiceAddress = item.Address;
            }
            if (item.Phone) {
                item.CustomerPhone = item.Phone;
            }
            if (item.Mobile) {
                item.CustomerMobile = item.Mobile;
            }
            setSelectedCustomerLocation(item.ProvinceID, item.CityID);
        }
        if (item.CardID || item.ID) {
            item.GuaranteeCardID = item.CardID ?? item.ID;
        }
        if (item.ProductID && item.SerialNumber) {
            const onGetInfo = (res) => {
                if (res.Data) {
                    const msg = `این سریال در تاریخ ${res.Data.SwapDate} جایگزین سریال ${res.Data.ProductSerial} شده است. شماره سرویس: ${res.Data.ServiceNumber}`;
                    setErrorDialog(dispatch, msg, "سریال محصول");
                }
            }
            getSwappedFromInfo(item.ProductID, item.SerialNumber, onGetInfo);
        }
        setServiceInfo({ ...serviceInfo, ...item, GuarantyCode: item.GuaranteeCardNo });
        getProductGInfo(item.ProductID, item.SerialNumber, item.GuaranteeCardID);

    }
    const getProductGInfo = async (pId, serial, gId) => {
        const result = await getProductGuaranteeInfo(pId, serial, gId);
        // if (result?.Message) {
        //     setErrorDialog(dispatch, result.Message, "اطلاعات کارت گارانتی محصول");
        // }
        setProductGCardMoreInfo(result.Data);
    }
    const setCustomerDesc = (desc) => {
        let el = document.getElementById("CustomerFaultsDesc");
        if (el.value !== "") {
            el.value = el.value + "," + desc;
        }
        else {
            el.value = desc;
        }
    }
    function calcG_TimeInMonth(date, isEnd) {
        //برای وقتی که مدت گارانتی از اطلاعات کالا دریافت شده و کاربر تاریخ شروع گارانتی را وارد می کند
        if (!(date?.length > 0)) {
            return;
        }
        if (!isEnd && Number(serviceInfo.GuaranteeTimeInMonth ?? 0) > 0 && (!gEndDate || gEndDate === '')) {
            addMonth(Number(serviceInfo.GuaranteeTimeInMonth));
            return;
        }
        //////
        if ((isEnd && (!gStartDate || gStartDate === '')) || (!isEnd && (!gEndDate || gEndDate === ''))) {
            return;
        }
        const endDate = isEnd ? date : gEndDate;
        const startDate = isEnd ? gStartDate : date;
        // let months = endDate.getMonth() - startDate.getMonth()
        //     + (12 * (endDate.getFullYear() - startDate.getFullYear()));

        // if (endDate.getDate() < startDate.getDate()) {
        //     months--;
        // }
        const result = getJalaliDiff(startDate, endDate);
        serviceInfo.GuaranteeTimeInMonth = result.months;
        if (isEnd) {
            serviceInfo.RemainedGuarantee = calcG_RemainedTime(gEndDate);
        }

    }
    function calcG_RemainedTime(endDate) {
        if (!endDate || endDate === '') {
            return;
        }
        // const eDate = new Date(endDate);
        // const now = new Date();
        // let remainedDays = eDate.getDate() - now.getDate();
        // let remainedInMonth = eDate.getMonth() - now.getMonth()
        //     + (12 * (eDate.getFullYear() - now.getFullYear()));
        // if (remainedDays < 0 && remainedInMonth > 0) {
        //     remainedInMonth--;
        //     //To Find Month Total Days
        //     remainedDays += new Date(eDate.getFullYear(), eDate.getMonth(), 0).getDate();
        // }
        const now = momentJalaali().local("en").format("YYYY-MM-DD");
        const result = getJalaliDiff(now, endDate);
        let remainedText = "";
        let color = "black";
        if (Math.abs(result.months) > 0) {
            remainedText = Math.abs(result.months) + " ماه ";
        }
        if (result.days !== 0) {
            if (remainedText.length > 0) {
                remainedText += " و ";
            }
            remainedText += Math.abs(result.days) + " روز";
        }
        if (result.months + result.days > 0) {
            remainedText += "مانده";
            color = "green";
        }
        else if (result.months < 0 || result.days < 0) {
            remainedText += "گذشته";
            color = "red";
        }
        if (remainedText !== "") {
            if (color === "red") {
                remainedText += " از پایان";
            }
            else {
                remainedText += " تا پایان"
            }
            return { Text: "[" + remainedText + "]", Color: color };
        }
        return "";


    }
    const addMonth = (month) => {
        if (gStartDate && gStartDate !== '') {
            const m = momentJalaali(gStartDate);
            const endDt = m.add("jMonth", Number(month));
            serviceInfo.GuaranteeEndDate = endDt.local("en").format("YYYY-MM-DD");
            serviceInfo.RemainedGuarantee = calcG_RemainedTime(serviceInfo.GuaranteeEndDate);
            serviceInfo.GuaranteeTimeInMonth = month;
            setEndDate(serviceInfo.GuaranteeEndDate);
        }
    }
    const attach = () => {
        const moreInfo = document.getElementById("serviceAttachMoreInfo").value;
        const inputFile = document.getElementById("serviceAttach");
        dispatch(attachFile(inputFile, serviceID, serviceType, () => { dispatch(getServiceAttachments(serviceType, serviceID)) }, moreInfo));
    }
    const deleteAttach = (id) => {
        dispatch(deleteAttachment(id, serviceType, () => { dispatch(getServiceAttachments(serviceType, serviceID)) }));
    }
    const checkSerialIsRequired = (e) => {
        const sType = e.target.value.toLowerCase();
        const r = (sType === "install" && systemSettings?.find(s => s.SettingName === "Services_SerialObligatoryInInstall")?.SettingValue.toLowerCase() === "true") ||
            (sType === "repair" && systemSettings?.find(s => s.SettingName === "Services_SerialObligatoryInRepair")?.SettingValue.toLowerCase() === "true");
        setSerialReq(r);
        const onGetInvoiceNumber = (res) => {
            if (res && res !== "Pending") {
                setServiceInfo({ ...serviceInfo, InvoiceNumber: res });
            }
        }
        if (sType !== "")
            getLastServiceNumber(sType, onGetInvoiceNumber);
    }
    const onSelectTab = (index) => {
        // if (index === 3) {
        //     dispatch(getServiceInvoice(serviceType, serviceID));
        // }
        switch (index) {
            case 0:
                setRowButtonsAlignment();
                break;
            case 2:
                setAttachFileType("file");
                dispatch(getServiceAttachments(serviceType, serviceID));
                break;
            case 3:
                dispatch(getMessageList(serviceType, serviceID));
                dispatch(getServiceEvents(serviceID, serviceType));
                break;
            case 4:
                dispatch(getServiceStaffPayments(serviceID, serviceType));
                break;
        }
    }
    const setSelectedCustomerLocation = (provinceID, cityID) => {
        loadCityList(provinceID);
        loadZoneList(cityID);
    }
    const onSubmit = (data) => {
        if (serviceID !== "0" && serviceInfo && serviceInfo.IsArchive) {
            setErrorDialog(dispatch, "این سرویس بایگانی شده و امکان ویرایش آن وجود ندارد", "ثبت اطلاعات پذیرش");
            return;
        }
        if (serviceID !== "0" && serviceInfo && serviceInfo.IsNotInLastDuration) {
            setErrorDialog(dispatch, "این سرویس مربوط به دوره مالی قبل است و امکان ویرایش آن وجود ندارد", "ثبت اطلاعات پذیرش");
            return;
        }
        //زمانی که کادر ورودی نوع پذیرش غیرفعال باشد(در هنگام ویرایش غیرفعال است)
        // این فیلد از سمت فرم پر نمی شود
        if (!data.ServiceType) {
            data.ServiceType = serviceType.toLowerCase();
        }

        data.ProductId = Number(data.ProductId);
        data.ServiceAddressLatitude = currentLocation?.lat;
        data.ServiceAddressLongtitude = currentLocation?.lng;
        if (data.IsReturned !== true) {
            data.IsReturned = data.IsReturned && data.IsReturned.length > 0 ? true : false;
        }
        //Problem With CheckBoxes In React Hook Form
        if (data.SupportID !== true) {
            data.SupportID = data.SupportID && data.SupportID.length > 0 ? 1 : 2;
        }
        else {
            data.SupportID = 1;
        }
        if (data.IsGuaranteeCanceled !== true) {
            data.IsGuaranteeCanceled = data.IsGuaranteeCanceled.length > 0 ? true : false;
        }
        if (data.CheckBoxExtAttr1 !== true)
            data.CheckBoxExtAttr1 = data.CheckBoxExtAttr1 && data.CheckBoxExtAttr1.length > 0 ? true : false;

        if (data.CheckBoxExtAttr2 !== true) {
            data.CheckBoxExtAttr2 = data.CheckBoxExtAttr2 && data.CheckBoxExtAttr2.length > 0 ? true : false;
        }
        if (data.CheckBoxExtAttr3 !== true) {
            data.CheckBoxExtAttr3 = data.CheckBoxExtAttr3 && data.CheckBoxExtAttr3.length > 0 ? true : false;
        }
        if (data.CheckBoxExtAttr4 !== true) {
            data.CheckBoxExtAttr4 = data.CheckBoxExtAttr4 && data.CheckBoxExtAttr4.length > 0 ? true : false;
        }
        if (data.CheckBoxExtAttr5 !== true) {
            data.CheckBoxExtAttr5 = data.CheckBoxExtAttr5 && data.CheckBoxExtAttr5.length > 0 ? true : false;
        }
        if (data.CheckBoxExtAttr6 !== true) {
            data.CheckBoxExtAttr6 = data.CheckBoxExtAttr6 && data.CheckBoxExtAttr6.length > 0 ? true : false;
        }

        if (serviceID && serviceID !== "0") {
            data.ServiceID = Number(serviceID);
        }
        if (Number(data.SupportID) === 1) {
            if (!gStartDate || gStartDate === "" || !gEndDate || gEndDate === "") {
                return;
            }
            data.GuaranteeStartDate = gStartDate;
            data.GuaranteeEndDate = gEndDate;
        }
        if (firstContactDate && firstContactDate !== "") {
            data.FirstContactDate = firstContactDate;
        }
        if (serviceDeadline && serviceDeadline !== "") {
            data.ServiceDeadline = serviceDeadline;
        }
        data.DurationalDeadline = durationalDeadline;
        if (productCreationDate && productCreationDate !== "") {
            data.ProductCreationDate = productCreationDate;
        }
        //موارد زیر برای ارسال پیامک پر میشوند
        serviceInfo.FirstContactDate = firstContactDate;
        serviceInfo.ServiceType = data.ServiceType;
        //مورد زیر برای ارجاع به کاربر پر می شود
        serviceInfo.ServiceDeadline = data.ServiceDeadline;
        dispatch(applyService(data, (res, returnedServiceType) => {
            if (Number(serviceID) === 0) {
                informCustomerOnServiceCreate();
                if (res.Data?.ServiceID)
                    history.push(`/Services/Service/${res.Data.ServiceID}/${returnedServiceType}`, null);
                window.scrollTo(0, 0);
            }
            else {
                if (Number(serviceInfo.StatusID) === -1) {
                    serviceInfo.Status = "پذیرش شد";
                }
                serviceInfo.Latitude = currentLocation?.lat;
                serviceInfo.Longitude = currentLocation?.lng;
                // Object.assign(serviceInfo, data);
                // setServiceInfo({...serviceInfo});
            }
        }));
    }
    const updateGuaranteeCard = () => {

        let card = {};
        card.GuaranteeStartDate = gStartDate;
        card.GuaranteeEndDate = gEndDate;
        card.ServiceID = serviceID;
        card.ServiceType = serviceType;
        card.ID = serviceInfo.GuaranteeCardID;
        card.ProductID = serviceInfo.ProductID;
        serviceInfo.GuaranteeStartDate = gStartDate;
        serviceInfo.GuaranteeEndDate = gEndDate;
        serviceInfo.SupportID = 1;
        setServiceGuarantee(true);
        serviceInfo.RemainedGuarantee = calcG_RemainedTime(gEndDate);
        card.GuaranteeCardNo =
            card.SerialNumber = document.getElementById("GSerialNumber").value;
        card.GuaranteeCardNo = document.getElementById("GuaranteeCardNo").value;
        serviceInfo.GuarantyCode = card.GuaranteeCardNo;
        if (!((serviceInfo.GuaranteeCardID) > 0) && !addCard) {
            setErrorDialog(dispatch, "ثبت کارت گارانتی از سرویس ها مجاز نیست. به تنظیمات مراجعه کنید.", "ثبت کارت گارانتی");
            return;
        }
        setServiceInfo({ ...serviceInfo });
        dispatch(updateGuarantee(card));
    }
    function showCommand() {
        setPopCommand({
            show: true,
            attachmentType: serviceType,
            attachmentID: serviceID
        })
    }
    function showDocRefer() {
        const onStatusChanged = (statusID, stageName) => {
            const status = serviceStatusList.find(s => Number(s.ID) === Number(statusID));
            setServiceInfo({ ...serviceInfo, StatusID: statusID, Status: status.Status, StageName: stageName });
        }
        setReferDocPop({ show: true, documentHardCode: serviceType, documentID: serviceID, documentNumber: serviceInfo?.InvoiceNumber, stageID: serviceInfo?.StageID, workDeadline: serviceInfo.ServiceDeadline, onStatusChanged: onStatusChanged });
    }
    function updateConsideration() {
        if (considerDescInput.current.value === "") {
            return;
        }
        const onUpdate = (res) => {
            if (res.Data) {
                serviceInfo.ConsiderDescriptionID = considerDescInput.current.value;
                setErrorDialog(dispatch, "success", "ثبت ملاحظه سرویس");
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت ملاحظه سرویس");
            }
        }
        updateServiceConsideration(serviceType, serviceID, considerDescInput.current.value, onUpdate);
    }
    function stop() {
        if (!serviceInfo.StopDesc || serviceInfo.StopDesc === "") {
            return;
        }
        const onStopDone = (res) => {
            if (res.Data) {
                serviceInfo.StoppedInStatus = true;
                setErrorDialog(dispatch, "success", "توقف سرویس");
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "توقف سرویس");
            }
        }
        stopService(serviceType, serviceID, serviceInfo.StopDesc, onStopDone);
    }
    function resume() {
        const onResumeDone = (res) => {
            if (res.Data) {
                serviceInfo.StoppedInStatus = false;
                setErrorDialog(dispatch, "success", "ادامه کار سرویس");
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ادامه کار سرویس");
            }
        }
        resumeService(serviceType, serviceID, onResumeDone);
    }
    function onReceptionInAgent(recInAgent) {
        if (recInAgent === "true" && (selectedStaff || serviceInfo?.AgencyID)) {
            if (selectedStaff)
                setParentStaff(selectedStaff.ID);
            else {
                setParentStaff(serviceInfo.AgencyID);
            }
        }
        else {
            setParentStaff(null);
        }
    }
    const onClose = useCallback((event) => {
        event.preventDefault();
        event.returnValue = "";
        if (Number(serviceID) > 0 && checkOut.current) {

            networkManager_CheckOut({ DocType: serviceType, DocID: serviceID });
        }
        return "";
    })
    function setNetCheckIn(res) {
        if (res.Message || res.Error) {
            checkOut.current = false;
            setCheckedIn(false);
        }
        else {
            checkOut.current = true;
            setCheckedIn(true);
        }
    }
    function changeStatus() {
        if (!Number(statusID.current) > 0) {
            return;
        }
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "تغییر وضعیت سرویس");
                return;
            }
            else if (res !== "PENDING") {
                serviceInfo.StatusID = statusID.current;
                const status = serviceStatusList.find(s => Number(s.ID) === Number(statusID.current));
                serviceInfo.Status = status.Status;
                serviceInfo.StageName = status.StageName;
                if (sendStatusSMS) {
                    sendSMSToCustomer();
                }
                setErrorDialog(dispatch, res, "تغییر وضعیت سرویس");
            }
        }
        changeServiceStatus(serviceType, serviceID, statusID.current, onSuccess)
    }
    const popover = (

        (<Popover id="popover-basic" style={{ fontFamily: "vazir" }}>
            <Popover.Title as="h4" className="headerStyle">
                <Toggles size={18
                } />&nbsp;
                تغییر وضعیت سرویس</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "6px" }}>
                <FormGroup>
                    <select className="form-control" onChange={e => statusID.current = e.target.value} defaultValue={serviceInfo?.StatusID}>
                        <option value="">انتخاب کنید</option>
                        {serviceStatusList && Array.isArray(serviceStatusList) &&
                            serviceStatusList.filter(s => s.Hard_Code !== "WaitingForReception" &&
                                s.Hard_Code !== "rejected" &&
                                s.Hard_Code !== "sent" &&
                                s.Hard_Code !== "deliveredtocust" &&
                                s.Hard_Code !== "senttocust" && (!(serviceInfo?.AuthorizedStatusHardCodes?.length > 0) || serviceInfo?.AuthorizedStatusHardCodes.some(ss => ss === s.Hard_Code)))
                                .map((ss, i) => <option key={i} value={ss.ID}>{ss.Status}</option>)}
                    </select>
                </FormGroup>
                <FormGroup >

                    <input className="form-check-input" type="checkbox" onChange={e => setSendStatusSMS(e.target.checked)} />&nbsp;
                    <span style={{ fontSize: "12px" }}>ارسال پیامک به مشتری</span>
                </FormGroup>
                <Button variant="success" className="group-Btn-smalll mt-2" onClick={changeStatus}><Check2Circle size={18} />&nbsp; ثبت وضعیت</Button>
            </Popover.Content>
        </Popover>)
    );
    const popNewProduct = (

        (<Popover id="popover-basic" style={{ fontFamily: "vazir", minWidth: "max-content", fontSize: "12px" }}>
            <Popover.Title as="h4" className="headerStyle">
                <Toggles2 size={18} />&nbsp;
                محصول جایگزین
            </Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "6px" }}>
                <table>
                    <tbody>
                        <tr>
                            <td>مارک محصول: </td>
                            <td style={{ fontWeight: "bold" }}>{serviceInfo?.NewProductHolder}</td>
                        </tr>
                        <tr>
                            <td>نوع/نام محصول:</td>
                            <td style={{ fontWeight: "bold" }}>{serviceInfo?.NewProductName}</td>
                        </tr>
                        <tr>
                            <td>مدل محصول: </td>
                            <td style={{ fontWeight: "bold" }}>{serviceInfo?.NewProductModel}</td>
                        </tr>
                        <tr>
                            <td>سریال محصول جدید:</td>
                            <td style={{ fontWeight: "bold", fontFamily: "Dark-Sans", fontSize: "11.5px" }}>{serviceInfo?.NewProductSerial}</td>
                        </tr>
                        <tr>
                            <td>تاریخ جایگزینی: </td>
                            <td style={{ fontWeight: "bold" }}>{serviceInfo?.PSwapDate}</td>
                        </tr>
                    </tbody>
                </table>
                <Button className="group-Btn-smalll mt-1" variant="danger" onClick={() => removeSwappedSerial(serviceID, onRemoveSwap)} disabled={serviceInfo?.StoppedInStatus}><DashCircle size={17} />&nbsp;حذف محصول جایگزین</Button>
            </Popover.Content>
        </Popover>)
    );
    function checkFieldPermission(fieldName, actionType) {
        let result = actionType === "Read";

        let field = fieldList?.find(f => (f.PageName?.toLowerCase() === serviceType) && f.Name.toLowerCase() === fieldName?.toLowerCase());
        if (actionType === "Read" && field) {
            result = field.IsRead === true;
        }
        if (actionType === "Edit" && field) {
            result = field.IsUpdate === false;
        }
        return result;
    }
    function getData() {
        const onGetSystemSettings = (settings) => {
            defaultServicType = Array.isArray(settings) ? (settings.find(s => s.SettingName === "ServiceTypeDefaultValue")?.SettingValue ?? "install") : "install";
            const onGetInvoiceNumber = (res) => {
                if (res === "Pending") {
                    setServiceInfo("Pending");
                }
                else {
                    setServiceInfo({ ...cardInfo, InvoiceNumber: res });
                }
            }
            if (!(Number(serviceID) > 0)) {
                getLastServiceNumber(defaultServicType ?? "install", onGetInvoiceNumber);
            }
        }
        dispatch(getSystemSettings(settingNames, onGetSystemSettings));
        if (!serviceExtraAttrSettings || !Array.isArray(serviceExtraAttrSettings) || serviceExtraAttrSettings.length < 2) {
            dispatch(getExtAttrSettings());
        }
        if (!provinceList || !Array.isArray(provinceList) || provinceList.length < 2) {
            dispatch(getAllProvinces());
        }
        if (!defaultStorages || Object.keys(defaultStorages).length < 2) {
            dispatch(getDefaultStoragesInfo());
        }
        if (Number(serviceID) > 0) {
            const onGetData = (res) => {
                if (res) {
                    if (res.Message) {
                        setErrorDialog(dispatch, res.Message, "دریافت سرویس");
                        return;
                    }
                    if (res !== "Pending") {
                        window.addEventListener('beforeunload', onClose);
                        dispatch(networkManager_CheckIn({ DocType: serviceType, DocID: serviceID }, setNetCheckIn));
                        setServiceGuarantee(Number(res?.SupportID) === 1);
                        res.RemainedGuarantee = calcG_RemainedTime(res.GuaranteeEndDate);
                        getCustomerServiceCountByID(res.CustomerID, setCustomerServiceCount);
                        if (Number(res.ProvinceID) > 0) {
                            dispatch(getCityList(res.ProvinceID));
                        }
                        if (Number(res.CityID) > 0) {
                            dispatch(getZoneList(res.CityID));
                        }
                    }
                    async function loadSInfo() {
                        setServiceInfo(res)
                    }
                    loadSInfo().then(() => {
                        setRowButtonsAlignment();
                        window.addEventListener("resize", setRowButtonsAlignment);
                    });
                }
            }
            getServiceWithCallBack(serviceType, serviceID, onGetData);
            dispatch(getStaffReportList());
            dispatch(loadServiceAccessories(serviceID, serviceType));
            if (!serviceStatusList || serviceStatusList.length === 0) {
                dispatch(getServiceStatusList());
            }
            if (serviceType === "repair") {
                dispatch(getRepairBugList(serviceID));
            }
        }
        else {
            if (cardInfo) {
                setServiceGuarantee(true);
                setCustomerAndProductFromSerial(cardInfo);
            }
        }
        if (serviceExtraAttrSettings && serviceExtraAttrSettings.length > 0) {
            window.serviceExtraAttrSettings = serviceExtraAttrSettings;
        }
        if (!fieldList || fieldList.length === 0) {
            dispatch(getPageFieldList(""));
        }
    }
    function showModalHappyCall() {
        setModalHappyCall({
            show: true,
            ProductID: serviceInfo.ProductID,
            ServiceType: serviceType,
            ServiceID: serviceID,
            ProductName: serviceInfo.ProductName,
            ProductModel: serviceInfo.ProductModel,
            InvoiceNumber: serviceInfo.InvoiceNumber,
            PServiceType: serviceType === "repair" ? "تعمیر" : "نصب",
            ProductSerial: serviceInfo.SerialNumber,
            CustomerPhone: serviceInfo.CustomerPhone,
            CustomerMobile: serviceInfo.CustomerMobile,
            CustomerName: serviceInfo.CustomerName,
            ContactDate: momentJalaali(serviceInfo.FirstContactDate.substring(0, 10)).format("jYYYY/jMM/jDD HH:mm"),
            SendDeliveryDate: momentJalaali(serviceInfo.SendDeliveryDate?.substring(0, 10)).format("jYYYY/jMM/jDD HH:mm")
        })
    }
    function delService() {
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف سرویس',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: deleteService(serviceType, serviceID, () => history.push("/Services/myTasks"))
        }))

    }
    function informCustomerOnServiceCreate() {
        if (!(Number(serviceID) > 0) && serviceInfo.CustomerMobile?.length > 10) {
            let sendSMS = false;
            if (serviceInfo.ServiceType.toLowerCase() === "install") {
                sendSMS = systemSettings.find(s => s.SettingName === "SMS_InformCustomerOnCreateInstall")?.SettingValue?.toLowerCase() === "true";
            }
            else if (serviceInfo.ServiceType.toLowerCase() === "repair") {
                sendSMS = systemSettings.find(s => s.SettingName === "SMS_InformCustomerOnCreateRepair")?.SettingValue?.toLowerCase() === "true";
            }
            if (sendSMS) {
                let smsBody = systemSettings.find(s => s.SettingName === "SendingSMS_InformCustomerOnServiceCreate")?.SettingValue;
                smsBody = smsBody.replace("*ن.م*", serviceInfo.CustomerName);
                smsBody = smsBody.replace("*م*", serviceInfo.CustomerCode);
                smsBody = smsBody.replace("*م.ح*", serviceInfo.ProductName);
                smsBody = smsBody.replace("*م.د*", serviceInfo.ProductModel);
                smsBody = smsBody.replace("*ت.ث*", momentJalaali(serviceInfo.FirstContactDate).format("jYYYY/jMM/jDD ساعت HH:mm"));
                smsBody = smsBody.replace("*ش.ک*", serviceInfo.InvoiceNumber);
                setModalSMS({
                    show: true,
                    text: smsBody,
                    to: serviceInfo.CustomerMobile
                })
            }
        }
    }
    function sendSMSToCustomer() {
        if (serviceInfo.CustomerMobile?.length > 9) {
            const sendData = [{
                Name: serviceInfo.CustomerName,
                ProductModel: serviceInfo.ProductModel,
                ProductName: serviceInfo.ProductName,
                ProductHolder: serviceInfo.HolderName,
                ServiceStatus: serviceInfo.Status,
                ProductSerial: serviceInfo.SerialNumber,
                MobileNumber: serviceInfo.CustomerMobile,
                ServiceNumber: serviceInfo.InvoiceNumber,
                GuaranteeNumber: serviceInfo.GuarantyCode,
                GuaranteeStartDate: serviceInfo.GuaranteeStartDate?.length > 1 ? momentJalaali(serviceInfo.GuaranteeStartDate).local("en").format("jYYYY/jMM/jDD") : "",
                GuaranteeEndDate: serviceInfo.GuaranteeEndDate?.length > 1 ? momentJalaali(serviceInfo.GuaranteeEndDate).local("en").format("jYYYY/jMM/jDD") : "",
                FirstContactDate: momentJalaali(serviceInfo.FirstContactDate).local("en").format("jYYYY/jMM/jDD"),
                Address: serviceInfo.ServiceAddress
            }];
            setModalSMS({
                show: true,
                sendData: sendData,
                to: serviceInfo.CustomerMobile
            })
        }
    }
    function sendProductReadySMS() {
        if (serviceInfo.CustomerMobile?.length > 10) {
            let sendSMS = false;
            if (serviceInfo.ServiceType.toLowerCase() === "install") {
                sendSMS = systemSettings.find(s => s.SettingName === "SendInstallDoneSMSToCustomer")?.SettingValue?.toLowerCase() === "true";
            }
            else if (serviceInfo.ServiceType.toLowerCase() === "repair") {
                sendSMS = systemSettings.find(s => s.SettingName === "SendRepairDoneSMSToCustomer")?.SettingValue?.toLowerCase() === "true";
            }
            if (sendSMS) {
                let smsBody = systemSettings.find(s => s.SettingName === "SendingSMS_SendServiceDoneSMSBodyToCustomer")?.SettingValue;
                smsBody = smsBody.replace("*ن.م*", serviceInfo.CustomerName);
                smsBody = smsBody.replace("*م*", serviceInfo.CustomerCode);
                smsBody = smsBody.replace("*م.ح*", serviceInfo.ProductName);
                smsBody = smsBody.replace("*م.د*", serviceInfo.ProductModel);
                smsBody = smsBody.replace("*ه.ت*", serviceInfo.AmountCustomerShouldPay?.toLocaleString("en"));
                smsBody = smsBody.replace("*ش.ک*", serviceInfo.InvoiceNumber);
                smsBody = smsBody.Replace("*و.س*", serviceInfo.Status);
                setModalSMS({
                    show: true,
                    text: smsBody,
                    to: serviceInfo.CustomerMobile
                })
            }
        }
    }
    function showModalSubProduct() {
        setModalSubProducts({
            show: true,
            cardNo: serviceInfo.GuarantyCode,
            serialNumber: serviceInfo.SerialNumber,
            productName: serviceInfo.ProductName,
            productModel: serviceInfo.ProductModel,
            cardID: serviceInfo.GuaranteeCardID,
            onSelect: () => { }
        })
    }
    function showModalSwapSerial() {
        setModalSwapSerial({
            show: true,
            serviceInfo: serviceInfo,
            setServiceInfo: setServiceInfo
        })
    }
    const showCustomer = () => {
        if (Number(serviceInfo?.CustomerID) > 0)
            window.open("/CRM/AddEditCustomer/" + serviceInfo?.CustomerID);
    }
    function showModalDelivery() {
        setModalDelivery({ show: true });
    }
    function showModalServiceAcc() {
        setModalServiceAcc({ show: true });
    }
    function showModalServiceEvents() {
        setModalServiceEvents({
            show: true,
            serviceID: serviceID,
            serviceType: serviceType,
            customerID: serviceInfo?.CustomerID
        })
    }
    function gotoDocument() {
        const onGet = (res) => {
            if (res.DocumentID) {
                window.open(`/Accounting/AddEditDocument/${res.DocumentID}`);
            }
        }
        getDocumentIDByAttachment(serviceID, serviceType, onGet);
    }
    function onRemoveSwap(res) {
        if (res.Data) {
            setServiceInfo({
                ...serviceInfo,
                NewProductID: null,
                NewGuaranteeCardNo: null,
                NewProductSerial: null,
                NewProductName: null,
                NewProductModel: null,
                NewProductHolder: null,
                CustomerInDebtForSwap: 0,
                SwapPriceDifference: 0,
                PSwapDate: null
            });
            setErrorDialog(dispatch, "success", "تعویض محصول");

        }
        else if (res.Error) {
            setErrorDialog(dispatch, res.Error, "تعویض محصول");
        }

    }
    function showModalReminder() {
        setPopReminder({
            show: true
        })
    }
    async function handleVerifyDone(data) {
        const result = await verifyServiceDone(data);
        if (result.Data) {
            setServiceInfo(prev => ({ ...prev, DoneVerificationPhoneNumber: data.PhoneNumber }))
        }
        return result;
    }
    useEffect(() => {
        setParentStaff(null);
        setStaffData(null);
        //selectProduct({ HolderName: "", ProductName: "", ProductModel: "" });
        setProductCreationDate(null);
        setCustomerServiceCount(null);
        dispatch(getCityList());
        dispatch(getZoneList());
        setDeadline(null);
        setDurationalDeadline(null);
        setContactDate(null);
        setEndDate(null);
        setStartDate(null);
        setServiceGuarantee(false);
        getBaseInfoList(InfoTypes.ServiceConsiderDesc, setConsiderDescList);
        getBaseInfoList(InfoTypes.ServiceStopDesc, setStopDescList);
        getData();
        return () => {
            window.removeEventListener('beforeunload', onClose);
            window.removeEventListener("resize", setRowButtonsAlignment);
            if (Number(serviceID) > 0 && checkOut.current) {
                networkManager_CheckOut({ DocType: serviceType, DocID: serviceID });
            }
        }

    }, [serviceID, serviceType]);
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
    }, []);

    return (
        <div className="container-fluid mt-1">
            <br />
            {/*productGCardMoreInfo &&*/
                <Toast className="product-toast"
                    show={productGCardMoreInfo != null}
                    autohide
                    delay={60000}
                    onClose={() => setProductGCardMoreInfo(null)}
               >
                    <ToastHeader closeButton>
                        سایر اطلاعات محصول
                    </ToastHeader>
                    <ToastBody>
                        <table>
                            <tbody className="text-end">
                                <tr>
                                    <td>نام فروشگاه:</td>
                                    <td>{productGCardMoreInfo?.ShopName ?? ""}</td>
                                </tr>
                                <tr>
                                    <td>تاریخ تولید:</td>
                                    <td>{productGCardMoreInfo?.PProductCreationDate}</td>
                                </tr>
                                <tr>
                                    <td>تاریخ خرید:</td>
                                    <td>{productGCardMoreInfo?.PPurchaseDate}</td>
                                </tr>
                                <tr>
                                    <td>برند گارانتی کننده:</td>
                                    <td>{productGCardMoreInfo?.HolderName}</td>
                                </tr>
                            </tbody>
                        </table>
                    </ToastBody>
                </Toast>
            }
            <div className="card">
                <div className="card-header headerStyle"><FontAwesomeIcon icon={faToolbox} size="lg" /> &nbsp;
                    <label>{Number(serviceID) > 0 ? "ویرایش" : "ثبت"} سرویس شماره {serviceInfo?.InvoiceNumber ?? ""}
                        {Number(serviceInfo?.ConsiderDescriptionID) > 0 && webView &&
                            <span style={{ fontSize: "13px" }}>
                                &nbsp;[{serviceInfo.ConsiderDescription}]
                            </span>
                        }
                    </label>
                    {Number(serviceID) > 0 && <label style={{ float: "left" }}>ثبت کننده: {serviceInfo?.CreateByName} </label>}
                </div>
                {(!serviceInfo || serviceInfo === "" || serviceInfo === "Pending") && <Loader type="BallTriangle" color="#bb1370" height={45} width={45} className="bodyStyle" style={{ padding: "15px" }} />}
                {serviceInfo && serviceInfo !== "" && serviceInfo !== "Pending" &&
                    <div className="card-body bodyStyle">
                        {serviceID !== "0" && serviceInfo.IsNotInLastDuration === true && <img src={PastDuration} alt="" style={{ height: 'auto', width: 'auto', position: 'absolute', left: '25px', top: '60px', zIndex: "150" }} />}
                        {serviceID !== "0" && serviceInfo.IsArchive === true && serviceInfo.ArchiveDate &&
                            <div style={{ position: 'absolute', left: '0', top: '30px', zIndex: "150" }}>
                                <img src={IsArchivePic} alt="" style={{ height: 'auto', width: 'auto' }} />
                                <DatePicker className="archiveDate" disabled timePicker={true} isGregorian={false} setTodayOnBlur={false}
                                    value={momentJalaali(serviceInfo.ArchiveDate)} style={{ fontSize: "10px" }} inputJalaaliFormat="jYYYY/jMM/jDD HH:mm" />
                            </div>}
                        {serviceInfo?.DoneVerificationPhoneNumber?.length > 0 &&
                            <div style={{
                                position: 'absolute',
                                left: '120px',
                                top: '85px',
                                zIndex: "150",
                                border: '2px solid #0a893099',
                                boxShadow: '0 0 3px green',
                                textShadow: "0 1px green",
                                color: "#435443",
                                transform: "rotate(-5deg)",
                                padding: "1px",
                                fontSize: "11px"
                            }}>
                                شماره همراه تایید کننده: {serviceInfo?.DoneVerificationPhoneNumber}
                            </div>
                        }
                        {webView && serviceID !== "0" && serviceInfo &&
                            <Fragment>
                                <div style={{ position: 'absolute', right: '15px', top: '50px', fontSize: "12px" }}>
                                    <span style={{ borderRadius: "3px", minWidth: "75px", padding: "2px", border: "solid 2px #820941", color: "blue" }} title="وضعیت سرویس">
                                        <BoxArrowInDownLeft size={14} />&nbsp;{serviceInfo.StageName}<ArrowLeft />{serviceInfo.Status}
                                    </span>
                                    &nbsp;
                                    {serviceInfo.StaffName && <span style={{ borderRadius: "3px", minWidth: "75px", padding: "2px", border: "solid 2px #820941", color: "blue" }} title="تکنسین اعزامی"><PersonSquare />{serviceInfo.StaffName}</span>}&nbsp;
                                    {serviceInfo.SendStaffDate && window.innerWidth > 1310 &&
                                        <div style={{ display: "inline-block", borderRadius: "3px", minWidth: "75px", padding: "2px", border: "solid 2px #820941", color: "blue" }}>
                                            <Clock style={{ display: "inline-block" }} />
                                            <div style={{ display: "inline-block" }} title="تاریخ اعزام">
                                                <DatePicker isGregorian={false} disabled value={momentJalaali(serviceInfo.SendStaffDate)} setTodayOnBlur={false}
                                                    inputJalaaliFormat="jYYYY/jMM/jDD HH:mm" className="sendStaffDate" />
                                            </div>
                                        </div>}
                                </div>
                                {serviceInfo.StoppedInStatus &&
                                    <div style={{ position: 'absolute', left: '15px', top: '50px', fontSize: "12px" }} className="rightTooltip" data-tooltip={serviceInfo.StopDesc}>

                                        <span style={{ borderRadius: "3px", minWidth: "75px", padding: "2px", border: "solid 2px #820941", color: "blue", cursor: "default" }} ><StopCircle />&nbsp;متوقف شده است</span>

                                    </div>
                                }
                            </Fragment>}
                        <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={productGrouppingType} defaultSalePrice={pDefaultSalePrice}
                            defaultSalePriceLabel={pDefaultSalePriceLabel} defaultStorages={defaultStorages} />
                        <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} nationalCodeIsRequired={nationalCodeIsRequired} />
                        <ModalSerialHistory serialIsEnglish={serialIsEnglish} />
                        <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />
                        <ModalCommands popData={popCommand} setPopData={setPopCommand} />
                        <ModalHappyCall popData={modalHappyCall} setPopData={setModalHappyCall} />
                        <ModalSendSMS popData={modalSMS} setPopData={setModalSMS} templateType="services" />
                        <ModalSwapSerial popData={modalSwapSerial} setPopData={setModalSwapSerial} />
                        <ModalReminder pop={popReminder} setPop={setPopReminder} attachmentID={serviceID} attachmentType={serviceType} />
                        {serviceInfo &&
                            <ModalServiceDelivery popData={modalDelivery} setPopData={setModalDelivery} serviceInfo={serviceInfo} checkedIn={checkedIn} setServiceInfo={setServiceInfo} sendSMSToCustomer={sendSMSToCustomer} />
                        }
                        {(Number(serviceID) > 0) && checkFieldPermission(serviceType + "Accounting", "Read") &&
                            <ModalServiceAccounting popData={modalServiceAcc} setPopData={setModalServiceAcc} serviceInfo={serviceInfo} checkedIn={checkedIn} setServiceInfo={setServiceInfo} />}
                        {(Number(serviceID) > 0) && checkFieldPermission(serviceType + "MessagesAndEvents", "Read") &&
                            <ModalServiceEvents popData={modalServiceEvents} setPopData={setModalServiceEvents} />}
                        {(serviceInfo?.SerialNumber?.length > 0 || serviceInfo.GuaranteeCardNo?.length > 0) &&
                            <ModalGuaranteeSubProducts popData={modalSubProducts} setPopData={setModalSubProducts} />}
                        {signaturePopStaus.show === true && <Signature />}
                        {serviceID !== "0" && <ModalDefinedServices />}
                        {serviceID !== "0" && <ModalSelectProductBug />}
                        <ModalSelectFaultByCustomer />
                        {serviceID !== "0" && <ModalReferToOther serviceInfo={serviceInfo} />}
                        {serviceID !== "0" && <ModalReferDocument popData={popReferDoc} setPopData={setReferDocPop} />}
                        <ModalMap location={{
                            lat: serviceInfo?.Latitude ?? 35.6996,
                            lng: serviceInfo?.Longitude ?? 51.3380,
                            zoom: 9
                        }} />
                        <Tabs onSelect={index => onSelectTab(index)}>
                            <TabList>
                                <Tab>پذیرش</Tab>
                                <Tab disabled={!serviceID || serviceID === '0' || !serviceInfo.StaffID || !checkedIn}>انجام کار</Tab>
                                <Tab disabled={!serviceID || serviceID === '0'}>پیوست ها</Tab>
                                {webView && (Number(serviceID) > 0) && checkFieldPermission(serviceType + "MessagesAndEvents", "Read") && <Tab>رویدادها و پیام های داخلی</Tab>}
                                {webView && (Number(serviceID) > 0) && checkFieldPermission(serviceType + "Accounting", "Read") && <Tab disabled={!checkedIn}>حسابداری سرویس</Tab>}
                                {webView && serviceInfo &&
                                    <Tab disabled={!enableExit}>خروج</Tab>}
                            </TabList>

                            <TabPanel>
                                <form onSubmit={handleSubmit(onSubmit)} readOnly>
                                    <div className="row" style={{ position: "relative" }}>
                                        {window.innerWidth <= 414 && serviceID !== "0" && serviceInfo &&
                                            <div style={{ marginRight: "10px", color: "blue" }}>
                                                <span style={{ borderRadius: "3px", width: "auto", minWidth: "75px", border: "solid 2px #820941", padding: "4px" }}>
                                                    {serviceInfo.StoppedInStatus &&
                                                        <label className="rightTooltipParent" >
                                                            <StopCircle size={14} />
                                                            <span className="rightTooltip" style={{ minWidth: "20px", textAlign: "right" }}>
                                                                {serviceInfo.StopDesc}
                                                            </span>
                                                        </label>
                                                    }
                                                    <BoxArrowInDownLeft size={14} />&nbsp;{serviceInfo.Status}</span>
                                                &nbsp;
                                                {serviceInfo.StaffName && <span style={{ borderRadius: "3px", minWidth: "75px", border: "solid 2px #820941", padding: "3px" }}>{"تکنسین اعزامی: " + serviceInfo.StaffName}</span>}
                                            </div>
                                        }
                                        <div className="form-group col-md-1">
                                            <label className="ellipsisLabel"><label> نوع پذیرش </label><span style={{ color: "red" }}>*</span></label>
                                            <select className="form-control" name="ServiceType" disabled={Number(serviceID) > 0} onChange={e => checkSerialIsRequired(e)} ref={register({ required: true })}
                                                defaultValue={serviceType !== "0" ? serviceType.toLowerCase() : defaultServicType}>
                                                <option value="">انتخاب کنید</option>
                                                <option value="repair"> تعمیر </option>
                                                <option value="install"> نصب </option>
                                            </select>
                                            {errors.ServiceType && <small className="errors"> نوع را وارد کنید </small>}
                                        </div>
                                        {roleList && roleList.find(s => s === "Reception") && !roleList.find(s => s === "Staff") && !roleList.find(s => s === "Agent") &&
                                            <div className='form-group  col-md-2'>
                                                <label className="ellipsisLabel">نام نماینده</label>
                                                <input type='hidden' name="AgencyID" value={selectedStaff?.ID ?? serviceInfo?.AgencyID ?? ""} ref={register({})} readOnly />
                                                <input placeholder='نماینده را انتخاب کنید' type="text" className='form-control' value={selectedStaff?.LastName ?? serviceInfo?.AgencyName ?? "دفتر مرکزی"} readOnly />
                                                <Button className="btn-input-tiny" onClick={showModalStaff} style={{ marginTop: "-1px" }}><List size={20} /></Button>
                                            </div>
                                        }

                                        <div className="form-group col-md-1">
                                            <label className="ellipsisLabel"><label> محل پذیرش </label><span style={{ color: "red" }}>*</span></label>
                                            <select className="form-control" name="ReceptionInAgent" ref={register({ required: true })} defaultValue={serviceID === "0" ? false : serviceInfo.ReceptionInAgent} onChange={e => onReceptionInAgent(e.target.value)}>
                                                <option value=""> لطفا انتخاب کنید </option>
                                                <option value={false}>دفتر مرکزی</option>
                                                <option value={true}>نمایندگی</option>
                                            </select>
                                            {errors.ReceptionInAgent && <small className="errors">الزامی است</small>}
                                        </div>
                                        <div className="form-group col-md-2" style={{ paddingLeft: webView ? 0 : "12px" }}>
                                            <label className="ellipsisLabel"> <label> تاریخ و ساعت پذیرش </label><span style={{ color: "red" }}>*</span> </label>
                                            <DatePicker popperPlacement="top-start" isGregorian={false} timePicker={true} className="form-control" setTodayOnBlur={false}
                                                onChange={value => { setContactDate(value.local("en").format("YYYY-MM-DD HH:mm")); }}
                                                inputJalaaliFormat="jYYYY/jMM/jDD ساعت HH:mm" inputFormat="YYYY-MM-DD HH:mm" value={serviceInfo?.FirstContactDate ? momentJalaali(serviceInfo.FirstContactDate) : firstContactDate ? momentJalaali(firstContactDate) : momentJalaali()} />
                                        </div>
                                        <div className="form-group col-md-2">
                                            <label className="ellipsisLabel">
                                                {(serviceInfo?.SerialNumber?.length > 0 || serviceInfo?.GuaranteeCardNo?.length > 0) &&
                                                    <label title="فهرست قطعات"> <InfoCircle onClick={showModalSubProduct} size={17} color="blue" style={{ cursor: "pointer" }} />&nbsp; </label>
                                                }
                                                <label>شماره سریال محصول </label>{(serialIsRequired) && <span style={{ color: "red" }}>*</span>}
                                            </label>
                                            {Number(serviceID) > 0 ?
                                                <Fragment>
                                                    <input className="form-control" name="SerialNumber" ref={register({ required: (serialIsRequired) })} type="text" lang="en"
                                                        defaultValue={serviceInfo?.SerialNumber ?? ''} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} readOnly={serialIsReadonly} />
                                                </Fragment>
                                                :
                                                <Fragment>
                                                    <input className="form-control" name="SerialNumber" style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }}
                                                        onChange={(e) => { setServiceInfo({ ...serviceInfo, SerialNumber: e.target.value }); console.log(e) }} ref={register({ required: (serialIsRequired) })} type="text" lang="en"
                                                        value={serviceInfo?.SerialNumber ?? ''} readOnly={serialIsReadonly} />
                                                    <Button className="btn-input-tiny"
                                                        onClick={() => { dispatch(setSerialHistoryPopup({ status: 'show', onSetData: setCustomerAndProductFromSerial })) }}><List size={20} />
                                                    </Button>
                                                </Fragment>
                                            }
                                            {errors.SerialNumber && <small className="errors"> سریال را وارد کنید </small>}
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label>{productGrouppingType === 1 ? ('نام و مدل محصول') : ('مارک، نوع، مدل محصول')} </label><span style={{ color: "red" }}>*</span>
                                            <input type="hidden" name="ProductID" ref={register({ required: true })} readOnly value={serviceInfo?.ProductID ?? ""} />
                                            <input type="text" placeholder='محصول را انتخاب کنید' className="form-control" name="ProductName" ref={register({ required: true })}
                                                value={[serviceInfo?.HolderName, serviceInfo?.ProductName, serviceInfo?.ProductModel].filter(p => p?.length > 0).join("-")} readOnly />
                                            {!(Number(serviceInfo?.GuaranteeCardID) > 0 && Number(serviceInfo?.ProductID) > 0) && <Button className="btn-input-tiny" onClick={showModalProduct} style={{ marginTop: "-1px" }}><List size={20} /></Button>}
                                            {errors.ProductID && <small className="errors"> نام محصول را وارد کنید </small>}
                                        </div>
                                        <div className="form-group col-md-1">
                                            <label className="ellipsisLabel"> تاریخ تولید محصول </label>
                                            <DatePicker name="ProductCreationDate" isGregorian={false} timePicker={false} className="form-control" setTodayOnBlur={false}
                                                onChange={value => { setProductCreationDate(value.local("en").format("YYYY-MM-DD")); }}
                                                value={serviceInfo?.ProductCreationDate ? momentJalaali(serviceInfo.ProductCreationDate.substring(0, 10)) : productCreationDate ? momentJalaali(productCreationDate) : undefined} max={momentJalaali().add(1, "day")} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label className="ellipsisLabel" title={"کدملی: " + (!serviceInfo?.CustomerNationalCode || serviceInfo?.CustomerNationalCode.length === 0 ? "ثبت نشده" : serviceInfo?.CustomerNationalCode)}>
                                                <label style={{ cursor: "pointer" }} onClick={showCustomer}>
                                                    نام و کد مشتری
                                                </label><span style={{ color: "red" }}>*</span>
                                                {customerServiceCount?.Data && <label style={{ fontSize: "11px", fontWeight: "bold" }}>&nbsp;
                                                    [کل: {customerServiceCount.Data.ServiceCount}|&nbsp;
                                                    داخل سازمان: {customerServiceCount.Data.InDepServiceCount}|&nbsp;
                                                    مانده: {Math.abs(customerServiceCount.Data.RemainedAmount).toLocaleString("en") + (customerServiceCount.Data.RemainedAmount > 0 ? "بس" : "بد")} ]</label>}
                                            </label>
                                            <input type="hidden" name="CustomerID" ref={register({ required: true })} value={serviceInfo?.CustomerID ?? ""} readOnly />
                                            <input placeholder='مشتری را انتخاب کنید' type="text" className="form-control" name="CustomerName" ref={register({ required: true })}
                                                value={(serviceInfo.CustomerCode ? (serviceInfo.CustomerCode + "-") : "") + (serviceInfo.CustomerName ?? "")} readOnly />
                                            <Button className="btn-input-tiny" onClick={showModalCustomer}><List size={20} /></Button>
                                            {errors.CustomerName && <small className="errors"> نام مشتری را وارد کنید </small>}
                                        </div>
                                        <div className="form-group col-md-2">
                                            <label> تلفن/موبایل مشتری </label>
                                            <input type="text" className="form-control" name="CustomerMobile" lang='en' readOnly value={(serviceInfo?.CustomerMobile ?? '-') + '/' + (serviceInfo?.CustomerPhone ?? '-')} />
                                        </div>
                                        <div className="form-group col-md-1" style={{ paddingLeft: webView ? 0 : "12px" }}>
                                            <label className="ellipsisLabel"><label>نام استان</label>{locationIsRequired && <span style={{ color: "red" }}>*</span>}</label>
                                            {Array.isArray(provinceList ?? "") ?
                                                <select className="form-control" name="ProvinceID" ref={register({ required: locationIsRequired })} onChange={e => loadCityList(e.target.value)} value={serviceInfo.ProvinceID ?? ""}
                                                    style={{ paddingLeft: webView ? "3px" : "unset", paddingRight: webView ? "6px" : "unset" }}>
                                                    <option value="">انتخاب کنید</option>
                                                    {provinceList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                                </select> :
                                                <div className="form-control">
                                                    <Loader type="BallTriangle" color="#bb1370" width={25} height={25} />
                                                </div>
                                            }
                                            {errors.ProvinceID && <small className="errors">نام استان اجباری است</small>}

                                        </div>
                                        <div className="form-group col-md-1" style={{ paddingLeft: webView ? 0 : "12px" }}>
                                            <label className="ellipsisLabel"> <label>نام شهر</label>{locationIsRequired && <span style={{ color: "red" }}>*</span>}</label>
                                            {Array.isArray(cityList ?? "") ?
                                                <select className="form-control" name="CityID" ref={register({ required: locationIsRequired })} defaultValue={serviceInfo.CityID ?? ""} onChange={e => loadZoneList(e.target.value)}>
                                                    {cityList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                                </select>
                                                :
                                                <div className="form-control">
                                                    <Loader type="BallTriangle" color="#bb1370" width={25} height={25} />
                                                </div>
                                            }
                                            {errors.CityID && <small className="errors">نام شهر اجباری است</small>}
                                        </div>
                                        <div className="form-group col-md-1">
                                            <label className="ellipsisLabel">نام منطقه</label>
                                            {Array.isArray(zoneList ?? "") ?
                                                <select className="form-control" name="ZoneID" readOnly={true} ref={register({})} defaultValue={serviceInfo?.ZoneID ?? ""} onChange={e => changeZone(e.target.value)} >
                                                    <option value="">انتخاب کنید</option>
                                                    {zoneList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                                </select> :
                                                <div className="form-control">
                                                    <Loader type="BallTriangle" color="#bb1370" width={25} height={25} />
                                                </div>
                                            }
                                        </div>
                                        <div className="form-group col-md-4">
                                            <label> نشانی مشتری </label><span style={{ color: "red" }}>*</span>
                                            <input className="form-control" name="ServiceAddress" ref={register({ required: true })} type="text" defaultValue={serviceInfo.ServiceAddress ?? ""} style={{ paddingLeft: "35px" }} />
                                            {errors.ServiceAddress && <small className="errors"> نشانی اجباری است </small>}
                                            <Button className="btn-input-tiny" onClick={() => dispatch(setMapPop({ show: true }))}><GeoAltFill size={19} /></Button>
                                        </div>
                                        <div className='col-md-3' >
                                            <div className='form-control hideScroll' style={{ marginTop: '2.2rem', border: '1px solid #534082', padding: "5px", whiteSpace: "nowrap", overflowX: "auto" }}>
                                                <FormCheck name="SupportID" inline style={{ fontSize: "13px", minHeight: "0", color: "#d53e1c" }} ref={register({})} label="گارانتی" disabled={Number(serviceID) > 0}
                                                    checked={serviceIsGuarantee} onChange={(e) => setServiceGuarantee(e.currentTarget.checked)} />
                                                <FormCheck name="IsReturned" inline style={{ fontSize: "13px", minHeight: "0", color: "#d53e1c" }} label="برگشتی" ref={register({})} defaultChecked={serviceInfo?.IsReturned === true} />
                                                {/*چون خروج گارانتی از کارت خوانده میشود بنابراین باید فقط خواندنی و غیرقابل تغییر باشد */}
                                                {/* بعضی از مشتری ها ممکن است کارت گارانتی نداشته باشند. پس برای فقط خواندنی بودن شرط کارت گارانتی نیز باید اضافه شود */}
                                                <FormCheck name="IsGuaranteeCanceled" inline style={{ fontSize: "13px", minHeight: "0", color: "#d53e1c" }} label="خارج از گارانتی" ref={register({})} defaultChecked={serviceInfo?.IsGuaranteeCanceled ?? false} readOnly={Number(serviceInfo?.GuaranteeCardID) > 0} />
                                            </div>
                                        </div>
                                        <div className="form-group col-md-1">
                                            <label className="ellipsisLabel">تاریخ موعد</label>
                                            <DatePicker name="ServiceDeadline" isGregorian={false} timePicker={false} className="form-control" setTodayOnBlur={false}
                                                onChange={value => { setDeadline(value.local("en").format("YYYY-MM-DD")); }}
                                                value={serviceInfo?.ServiceDeadline ? momentJalaali(serviceInfo.ServiceDeadline.substring(0, 10)) : serviceDeadline ? momentJalaali(serviceDeadline) : undefined} min={minDate} />
                                        </div>
                                        <Col md={1} className="form-group" style={{ color: "blue" }}>
                                            <label className="ellipsisLabel">بازدید بعدی:</label>
                                            <DatePicker name="DurationalDeadline" isGregorian={false} timePicker={false} className="form-control" setTodayOnBlur={false}
                                                onChange={value => { setDurationalDeadline(value.local("en").format("YYYY-MM-DD")); }}
                                                value={serviceInfo?.DurationalDeadline ? momentJalaali(serviceInfo.DurationalDeadline.substring(0, 10)) : durationalDeadline ? momentJalaali(durationalDeadline) : undefined} min={minDate} />
                                        </Col>
                                        <Col md={1} className="form-group" style={{ paddingLeft: webView ? 0 : "12px" }} >
                                            <label className="ellipsisLabel">اولویت: </label>
                                            <select className="form-control" name="PriorityForWorkShop" ref={register({})} disabled={!enablePriority} defaultValue={Number(serviceInfo?.PriorityForWorkShop ?? 0)}>
                                                <option value={0}>پایین</option>
                                                <option value={1}>عادی</option>
                                                <option value={2}>بالا</option>
                                                <option value={3}>بسیار بالا</option>
                                            </select>
                                        </Col>
                                        <Col md={1} className="form-group" style={{ paddingLeft: webView ? 0 : "12px" }}>
                                            <label className="ellipsisLabel">سطح دشواری</label>
                                            <select className="form-control" name="HardnessID" ref={register({})} defaultValue={Number(serviceInfo?.HardnessID ?? 0)}>
                                                <option value={1}>آسان</option>
                                                <option value={2}>معمولی</option>
                                                <option value={3}>سخت</option>
                                                <option value={4}>مشکل ساز</option>
                                            </select>
                                        </Col>
                                        {(serviceIsGuarantee === true || Number(serviceInfo.SupportID) === 1) &&
                                            <Fragment>
                                                <input type="hidden" name="GuaranteeCardID" ref={register({})} value={serviceInfo?.GuaranteeCardID ?? null} readOnly />
                                                <div className="form-group col-md-1">
                                                    <label className="ellipsisLabel"> شماره گارانتی </label>
                                                    <input className="form-control" name="GuarantyCode" ref={register({})} type="text" lang='en' defaultValue={serviceInfo?.GuarantyCode ?? null}
                                                        disabled={serviceInfo?.IsGuaranteeCanceled} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                                </div>
                                                <div className="form-group col-md-1">
                                                    <label className="ellipsisLabel">آغاز گارانتی</label>
                                                    <DatePicker name="GaranteeStartDate" isGregorian={false} timePicker={false} className="form-control" setTodayOnBlur={false}
                                                        onChange={value => { calcG_TimeInMonth(value.local("en").format("YYYY-MM-DD"), false); setStartDate(value.local("en").format("YYYY-MM-DD")); }}
                                                        value={serviceInfo?.GuaranteeStartDate ? momentJalaali(serviceInfo.GuaranteeStartDate.substring(0, 10)) : gStartDate ? momentJalaali(gStartDate) : undefined}
                                                        disabled={serviceInfo?.IsGuaranteeCanceled || (Number(serviceID) > 0 && Number(serviceInfo.GuaranteeCardID) > 0)} />
                                                    {!gStartDate && <small className="errors">الزامی است</small>}
                                                </div>
                                                <div className="form-group col-md-1">
                                                    <label className="ellipsisLabel">پایان گارانتی</label>
                                                    <DatePicker className="form-control" name="GaranteeEndDate" isGregorian={false} timePicker={false} setTodayOnBlur={false}
                                                        onChange={value => { calcG_TimeInMonth(value.local("en").format("YYYY-MM-DD"), true); setEndDate(value.local("en").format("YYYY-MM-DD")); }}
                                                        value={serviceInfo?.GuaranteeEndDate ? momentJalaali(serviceInfo.GuaranteeEndDate.substring(0, 10)) : gEndDate ? momentJalaali(gEndDate) : undefined}
                                                        disabled={serviceInfo?.IsGuaranteeCanceled || (Number(serviceID) > 0 && Number(serviceInfo.GuaranteeCardID) > 0)} />
                                                    {!gEndDate && <small className="errors">الزامی است</small>}
                                                </div>
                                                {serviceInfo?.IsGuaranteeCanceled ?
                                                    <Col md={2} className="form-group">
                                                        <label style={{ color: "red" }}>دلیل خروج از گارانتی:</label>
                                                        <Form.Control value={serviceInfo.CancelDescription} style={{ borderColor: "red", color: "#ff0e00", fontWeight: "bold" }} />
                                                    </Col> :
                                                    <div className='form-group col-md-2'>
                                                        <label className="ellipsisLabel">مدت گارانتی(ماه)&nbsp;
                                                            <span style={{ color: serviceInfo?.RemainedGuarantee?.Color ?? "", fontSize: "11px" }}>
                                                                {serviceInfo?.RemainedGuarantee?.Text ?? ""}</span>
                                                        </label>
                                                        <input type="number" className='form-control' lang='en' onChange={(e) => addMonth(e.target.value)} value={serviceInfo?.GuaranteeTimeInMonth ?? "0"} />

                                                    </div>
                                                }

                                            </Fragment>
                                        }

                                    </div>
                                    <div className="row">
                                        <div className="form-group col-md-4">
                                            <label> اظهارات مشتری </label>
                                            <input className="form-control" name="CustomerDescription" id="CustomerFaultsDesc" ref={register({})} type="text" defaultValue={serviceInfo && serviceInfo.CustomerDescription ? serviceInfo.CustomerDescription : ''} />
                                            <Button className="btn-input-tiny" style={{ top: "27px" }}
                                                onClick={() => { dispatch(setCustomerFaultsPop({ status: 'show', setData: setCustomerDesc })) }}><List size={20} />
                                            </Button>
                                        </div>
                                        <div className="form-group col-md-4">
                                            <label> سایر توضیحات </label>
                                            <input className="form-control" name="Description" ref={register({})} type="text" defaultValue={serviceInfo?.Description ?? ''} />
                                        </div>
                                        <div className="form-group col-md-2">
                                            <label>شرح دستی سند</label>
                                            <input className="form-control" name="ManualDocDesc" ref={register({})} type="text" defaultValue={serviceInfo?.ManualDocDesc ?? ''} />
                                        </div>
                                        <Col md={2} className="form-group">
                                            <label className="ellipsisLabel">معرف:</label>
                                            <input type="hidden" name="MiddlemanID" ref={register({})} readOnly value={serviceInfo?.MiddlemanID ?? ""} />
                                            <input type="hidden" name="MiddlemanCat" ref={register({})} readOnly value={serviceInfo?.MiddlemanCat ?? ""} />
                                            <Form.Control name="MiddlemanName" ref={register({})} readOnly value={serviceInfo?.MiddlemanName ?? ""} onKeyDown={showModalMiddleman} />
                                            <Button className="btn-input-tiny" style={{ top: 26 }} onClick={showModalMiddleman}><List size={21} /></Button>
                                        </Col>
                                    </div>
                                    {serviceID !== "0" &&
                                        <Row className="mt-3" style={{ margin: 0 }}>
                                            <Col md={(serviceType?.toLowerCase() === "install" ? 12 : 6)} className="rowBorder">
                                                <div className="rowTitle">
                                                    لوازم همراه
                                                </div>
                                                <ServiceProductAccessories accessoryList={serviceAccessories} serviceID={serviceID} serviceType={serviceType} productID={serviceInfo.ProductID} productTypeID={serviceInfo.ProductTypeID} pgType={productGrouppingType} />
                                            </Col>
                                            {serviceType?.toLowerCase() === "repair" &&
                                                <Col md={6} className="rowBorder">
                                                    <div className="rowTitle">
                                                        ایرادات فنی
                                                    </div>
                                                    <RepairBugs serviceID={serviceID} productID={serviceInfo?.ProductID} productTypeID={serviceInfo.ProductTypeID} repairBugList={repairBugList} />
                                                </Col>
                                            }
                                        </Row>
                                    }
                                    {Array.isArray(serviceExtraAttrSettings ?? "") && serviceExtraAttrSettings.length > 0 &&
                                        <Row className="rowBorder mt-3">
                                            <div className="rowTitle">سایر اطلاعات سرویس</div>
                                            <ServicesExtAttr settings={serviceExtraAttrSettings} register={register} serviceInfo={serviceInfo} />
                                            {serviceExtraAttrSettings.find(s => s.SettingName.search("Services_CheckBoxExtAttr") >= 0) &&
                                                <ServiceCheckboxAttr settings={serviceExtraAttrSettings} register={register} serviceInfo={serviceInfo} />

                                            }

                                        </Row>
                                    }
                                    {isLoadingSaved && <div className="mt-2"><label><Loader type="BallTriangle" color="blue" height={25} width={25} /></label>&nbsp;<label style={{ color: "purple" }}>لطفا منتظر بمانید</label> </div>}
                                    {!isLoadingSaved &&
                                        <div className="mt-1" style={{ position: "sticky", bottom: "10px" }} ref={divButtons}>
                                            <Button type="submit" className="group-Btn" variant="success" disabled={!checkedIn || serviceInfo.StoppedInStatus}>
                                                {Number(serviceID) > 0 ?
                                                    <Fragment><Pencil size={16} /> ویرایش اطلاعات</Fragment> :
                                                    <Fragment><CheckLg size={16} /> ثبت اطلاعات</Fragment>}
                                            </Button>
                                            {serviceID !== "0" && checkedIn && <Button className="group-Btn" keyname="referStaff" style={{ backgroundColor: "#bd4906", borderColor: "#bd4906" }} onClick={showReferPop}><ArrowRightSquare size={17} />&nbsp;ارجاع به تکنسین</Button>}
                                            {showReceipt && <Button variant="secondary" className="group-Btn" keyname="command" onClick={showCommand}><Command size={17} />&nbsp;دستور کار</Button>}
                                            {showReceipt && checkedIn && <Button variant="info" className="group-Btn" keyname="referDoc" onClick={showDocRefer}><ReplyFill size={17} /><Person className='defaultIcon' />&nbsp;ارجاع به کاربر</Button>}
                                            {showReceipt && <Button className="group-Btn" keyname="custReceipt" onClick={printServiceReceipt}><Receipt size={17} />&nbsp; رسید مشتری </Button>}
                                            {showReceipt && <Button className="group-Btn btn-violet" keyname="staffForm" onClick={printStaffServiceForm}><Receipt size={17} />&nbsp; فرم تکنسین </Button>}
                                            {Number(serviceID) > 0 &&
                                                <Fragment>
                                                    {!serviceInfo.StoppedInStatus ?
                                                        <OverlayTrigger placement="top" trigger="click" overlay={popStopService} rootClose>
                                                            <Button className="group-Btn" variant="secondary" keyname="stop"><StopCircle size={18} />&nbsp;توقف سرویس</Button>
                                                        </OverlayTrigger> :
                                                        <Button className="group-Btn" variant="secondary" onClick={resume} keyname="resume"><CircleFill size={16} />&nbsp;ادامه کار</Button>
                                                    }
                                                    <OverlayTrigger overlay={popConsiderDescs} rootClose trigger="click">
                                                        <Button className="group-Btn" variant="info" keyname="considerDesc" disabled={serviceInfo.StoppedInStatus}><Clipboard2Check size={19} /> شرح رسیدگی</Button>
                                                    </OverlayTrigger>
                                                    <Button className="group-Btn" variant="danger" keyname="delete" onClick={delService} disabled={serviceInfo.StoppedInStatus}><DashCircle size={18} />&nbsp; حذف سرویس</Button>
                                                    <OverlayTrigger trigger="click" placement="top" overlay={popover} rootClose>
                                                        <Button className="group-Btn" variant="info"><Toggles size={18} />&nbsp;تغییر وضعیت سرویس</Button>
                                                    </OverlayTrigger>
                                                    <Button className="group-Btn btn-violet" keyname="happyCall" onClick={showModalHappyCall}><Headset size={18} /> &nbsp; رضایت سنجی</Button>
                                                    {serviceType.toLowerCase() === "repair" && !serviceInfo?.IsArchive && serviceInfo?.SerialNumber?.length > 0 &&
                                                        !(Number(serviceInfo?.NewProductID) > 0) &&
                                                        <Button className="group-Btn" variant="secondary" keyname="swap" onClick={showModalSwapSerial} disabled={serviceInfo.StoppedInStatus}><Toggle2On size={18} />&nbsp;جایگزینی محصول</Button>
                                                    }
                                                    {Number(serviceInfo?.NewProductID) > 0 &&
                                                        <OverlayTrigger placement="top" trigger="click" overlay={popNewProduct} rootClose>
                                                            <Button className="group-Btn" variant="secondary"><Toggles2 size={18} />&nbsp;محصول جایگزین</Button>
                                                        </OverlayTrigger>
                                                    }
                                                    <Button className="group-Btn" keyname="sms" onClick={sendSMSToCustomer}><Envelope size={16} />&nbsp;ارسال پیامک به مشتری</Button>
                                                    <Button className="group-Btn" keyname="reminder" variant="secondary" onClick={showModalReminder}><CalendarDate size={15} />&nbsp; یادآوری</Button>
                                                </Fragment>}
                                            {showMenuButton && Number(serviceID) > 0 && <OverlayTrigger overlay={popMenu} trigger="click" rootClose><Button className="btn-violet group-Btn"><List size={17} /></Button></OverlayTrigger>}
                                        </div>
                                    }
                                </form>
                            </TabPanel>
                            <TabPanel>
                                <Accordion defaultActiveKey="0">
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} eventKey="0" style={{ backgroundColor: "rgb(210 89 4)", textAlign: "right", fontSize: "14px" }}><Truck size={19} />&nbsp;مراجعه</Accordion.Toggle>
                                        <Accordion.Collapse eventKey="0">
                                            <Card.Body style={{ textAlign: 'right', backgroundColor: "#fff4eb" }}>
                                                <ServiceReferrals serviceInfo={serviceInfo} setServiceInfo={setServiceInfo} staffReportList={staffReportList} parentStaffID={parentStaffID} setPopSelectStaff={setPopStaff} sendSMSToCustomer={sendSMSToCustomer} popConsiderDescs={popConsiderDescs} />
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} eventKey="1" style={{ backgroundColor: "#12b5bd", textAlign: "right", fontSize: "14px" }}><LayoutWtf size={18} />&nbsp;قطعات مصرفی</Accordion.Toggle>
                                        <Accordion.Collapse eventKey="1">
                                            <Card.Body style={{ textAlign: 'right', backgroundColor: "#f2fafb" }}>
                                                <ServiceUsedParts serviceInfo={serviceInfo} setServiceInfo={setServiceInfo} setProductPopup={setPopProduct} />
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} eventKey="2" style={{ backgroundColor: "rgb(149 150 150)", textAlign: "right", fontSize: "14px" }}><LayoutTextSidebar size={18} />&nbsp;تعرفـه ها</Accordion.Toggle>
                                        <Accordion.Collapse eventKey="2">
                                            <Card.Body style={{ textAlign: 'right', backgroundColor: "#f4f4f4" }}>
                                                <ServiceDefinedServices serviceInfo={serviceInfo} setServiceInfo={setServiceInfo} parentStaffID={parentStaffID} setPopSelectStaff={setPopStaff} pgType={productGrouppingType} />
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} eventKey="3" style={{ backgroundColor: "rgb(96 122 216)", textAlign: "right", fontSize: "14px" }}><BagDash size={19} />&nbsp;سایـر خدمـات</Accordion.Toggle>
                                        <Accordion.Collapse eventKey="3">
                                            <Card.Body style={{ textAlign: 'right', backgroundColor: "#fafbff" }}>
                                                <ServiceExtraCosts serviceInfo={serviceInfo} setServiceInfo={setServiceInfo} parentStaffID={parentStaffID} setPopSelectStaff={setPopStaff} />
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card style={{ display: serviceType === "install" ? "none" : "flex" }}>
                                        <Accordion.Toggle as={Card.Header} eventKey="4" style={{ backgroundColor: "rgb(129 160 146)", textAlign: "right", fontSize: "14px" }}><LayoutTextSidebar size={18} />&nbsp; ایرادات فنی</Accordion.Toggle>
                                        <Accordion.Collapse eventKey="4">
                                            <Card.Body style={{ textAlign: 'right', paddingTop: 0 }}>
                                                <RepairBugs serviceID={serviceID} productID={serviceInfo?.ProductID} productTypeID={serviceInfo.ProductTypeID} repairBugList={repairBugList} />
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    {serviceInfo?.IsArchive !== true && !serviceInfo?.IsGuaranteeCanceled &&
                                        <Card>
                                            <Accordion.Toggle as={Card.Header} eventKey="5" style={{ backgroundColor: "rgb(213 85 109)", textAlign: "right", fontSize: "14px" }}><FileEarmarkCheck size={19} />&nbsp;مشخصات گارانتی</Accordion.Toggle>
                                            <Accordion.Collapse eventKey="5">
                                                <Card.Body style={{ textAlign: 'right', backgroundColor: "#ffedf1" }}>
                                                    {serviceInfo?.GuaranteeEndDate?.length > 2 && Number(serviceInfo?.SupportID) === 2 &&
                                                        <div><span style={{ color: "red" }}>محصول گارانتی دارد اما خدمت ارائه شده گارانتی نیست</span></div>}
                                                    <div className="row">
                                                        <div className="form-group col-md-2">
                                                            <label className="ellipsisLabel">شماره سریال</label>
                                                            <input className="form-control" name="SerialNumber" id="GSerialNumber" type="text" defaultValue={serviceInfo?.SerialNumber ?? ''} readOnly={Number(serviceInfo?.GuaranteeCardID) > 0} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                                        </div>
                                                        <div className="form-group col-md-2">
                                                            <label className="ellipsisLabel">شماره گارانتی</label>
                                                            <input className="form-control" id="GuaranteeCardNo" type="text" defaultValue={serviceInfo?.GuarantyCode ?? null} readOnly={Number(serviceInfo?.GuaranteeCardID) > 0} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                                        </div>
                                                        <div className="form-group col-md-2">
                                                            <label >تاریخ آغاز گارانتی</label>
                                                            <DatePicker isGregorian={false} timePicker={false} className="form-control" setTodayOnBlur={false}
                                                                onChange={value => { setStartDate(value.local("en").format("YYYY-MM-DD")); }}
                                                                value={serviceInfo?.GuaranteeStartDate ? momentJalaali(serviceInfo.GuaranteeStartDate.substring(0, 10)) : gStartDate ? momentJalaali(gStartDate) : undefined} />
                                                        </div>
                                                        <div className="form-group col-md-2">
                                                            <label>تاریخ پایان گارانتی</label>
                                                            <DatePicker className="form-control" isGregorian={false} timePicker={false} setTodayOnBlur={false}
                                                                onChange={value => { setEndDate(value.local("en").format("YYYY-MM-DD")); }}
                                                                value={serviceInfo?.GuaranteeEndDate ? momentJalaali(serviceInfo.GuaranteeEndDate.substring(0, 10)) : gEndDate ? momentJalaali(gEndDate) : undefined} />
                                                        </div>
                                                        <div className='form-group col-md-2'>
                                                            <label className="ellipsisLabel">مدت گارانتی(ماه)&nbsp;
                                                                <span style={{ color: serviceInfo?.RemainedGuarantee?.Color ?? "", fontSize: "11px" }}>
                                                                    {serviceInfo?.RemainedGuarantee?.Text ?? ""}</span>

                                                            </label>
                                                            <input type="number" className='form-control' lang='en' onChange={(e) => addMonth(e.target.value)} value={serviceInfo?.GuaranteeTimeInMonth ?? "0"} />

                                                        </div>
                                                    </div>
                                                    <Button className="group-Btn mt-2" variant="success" onClick={updateGuaranteeCard} disabled={serviceInfo.StoppedInStatus}>
                                                        {Number(serviceInfo?.GuaranteeCardID) > 0 ?
                                                            <Fragment>
                                                                <PencilFill size={15} />&nbsp;ویرایش گارانتی
                                                            </Fragment> :
                                                            <Fragment>
                                                                <Plus size={19} />ثبت گارانتی
                                                            </Fragment>}
                                                    </Button>
                                                    <Button variant="secondary" className="group-Btn mt-2" onClick={printGuaranteeCard}><Printer size={18} />&nbsp;چاپ کارت گارنتی</Button>

                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    }
                                </Accordion>
                                <div className='mt-2' style={{ textAlign: "right" }}>
                                    {showReceipt && <><Button className="group-Btn" onClick={printServiceReceipt}><Receipt size={17} />&nbsp; رسید مشتری </Button>
                                        {!(serviceInfo?.DoneVerificationPhoneNumber?.length > 0) &&
                                            <PopSMSOtp
                                                title="تایید انجام کار"
                                                entityID={serviceID}
                                                entityType={serviceType === "install" ? databaseEntities.Install : databaseEntities.Repair}
                                                externalPhoneNumber={serviceInfo.CustomerMobile}
                                                onVerify={handleVerifyDone}
                                            />}
                                    </>}
                                    {showReceipt && <Button className="group-Btn" variant="secondary" onClick={printStaffServiceForm}><ReceiptCutoff size={17} />{webView && <Fragment> &nbsp; فرم تکنسین </Fragment>}</Button>}
                                    {isMobile && serviceInfo && checkFieldPermission(serviceType + "SendOrDeliverByID", "Read") && <Button className="group-Btn" variant="info" onClick={showModalDelivery}><BoxArrowRight size={18} /> </Button>}
                                    {isMobile && (Number(serviceID) > 0) && checkFieldPermission(serviceType + "Accounting", "Read") && <Button className="group-Btn btn-violet" onClick={showModalServiceAcc}><Calculator size={18} /></Button>}
                                    {isMobile && (Number(serviceID) > 0) && checkFieldPermission(serviceType + "MessagesAndEvents", "Read") && <Button className="group-Btn" onClick={showModalServiceEvents}><Calendar2Day size={18} /></Button>}
                                </div>
                            </TabPanel>
                            <TabPanel>
                                {serviceInfo?.IsArchive !== true &&
                                    <>
                                        <FormGroup className="text-end col-md-6 mb-1">
                                            <label>نوع پیوست:</label>
                                            <select className="form-control" onChange={e => setAttachFileType(e.target.value)}>
                                                <option value="file">فایل</option>
                                                <option value="audio">ضبط صدا</option>
                                            </select>
                                        </FormGroup>
                                        {attachFileType === "file" &&
                                            <table style={{ width: "auto", minWidth: "50%" }}>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <input id="serviceAttach" className='form-control' type="file" multiple={true} style={{ lineHeight: "1.9", fontSize: "12px", backgroundColor: "#dedcdc", border: "solid 1px #534082" }}></input>
                                                        </td>
                                                        <td>
                                                            <Form.Control placeholder="توضیحات فایل" id="serviceAttachMoreInfo" style={{ lineHeight: "1.9", fontSize: "12px", backgroundColor: "#dedcdc", border: "solid 1px #534082" }} />
                                                        </td>
                                                        <td style={{ width: "25px" }}>
                                                            <Button className="group-Btn-smalll" onClick={attach}><CloudArrowUp size={23} /></Button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        }
                                        {attachFileType === "audio" &&
                                            <VoiceRecorder
                                                parentID={serviceID}
                                                parentType={serviceType}
                                                style={{ margin: isMobile ? "auto" : "unset" }}
                                                autoStart={true}
                                                onUpload={() => { dispatch(getServiceAttachments(serviceType, serviceID)) }}
                                            />
                                        }
                                    </>
                                }

                                <BihamtaTable columns={attachTableCols} rowButtons={attachTableButton} dataList={{ Data: serviceAttachments }} />
                            </TabPanel>
                            {webView &&
                                <Fragment>
                                    {(Number(serviceID) > 0) && checkFieldPermission(serviceType + "MessagesAndEvents", "Read") &&
                                        <TabPanel>
                                            <ServiceEvents_Messages serviceID={serviceID} serviceType={serviceType} customerID={serviceInfo?.CustomerID} />
                                        </TabPanel>
                                    }
                                    {(Number(serviceID) > 0) && checkFieldPermission(serviceType + "Accounting", "Read") &&
                                        <TabPanel>
                                            <ServiceAccountings serviceInfo={serviceInfo} setServiceInfo={setServiceInfo} checkedIn={checkedIn} />
                                        </TabPanel>
                                    }
                                    {serviceInfo && checkFieldPermission(serviceType + "SendOrDeliverByID", "Read") &&
                                        <TabPanel>
                                            <ServiceDeliverProduct serviceInfo={serviceInfo} checkedIn={checkedIn} setServiceInfo={setServiceInfo} sendSMSToCustomer={sendSMSToCustomer} popConsiderDescs={popConsiderDescs} />
                                        </TabPanel>}
                                </Fragment>}
                        </Tabs>
                    </div>}
            </div>

        </div >
    )
}
export default Service;
